// generated by stuff/i18n.py. DO NOT EDIT.
const translations: { [key: string]: string; } = {
  U13CannotPerform: "Coder under 13 years can not perform this action.",
  aboutSectionAlreadyReported: "You have already reported this profile.",
  aboutToStart: "You are about to start the contest. Once you click Start Contest your time will begin.",
  acceptCodeOfConduct: "I have read and accept the [Code of Conduct](%(CodeofConductPolicyURL)).",
  acceptPrivacyPolicy: "I have read and accept the site's [Use and Privacy Policy](%(PrivacyPolicyURL)).",
  accountDeleteCancel: "Cancel",
  accountDeleteConfirmationMessage: "Are you sure you want to delete your account?",
  accountDeleteMessage: "Click the following button if you wish to delete your account and all your personal information from omegaUp. This operation will take place immediately after you confirm that you want to do it and it is not reversible.",
  accountDeleteOk: "Delete",
  accountDeleteRequireConfirmation: "Confirmation Required",
  accountDeletionConfirmEmailBody: "%(username) confirmed to delete their account.",
  accountDeletionConfirmEmailSubject: "omegaup account deleted",
  accountDeletionRequestEmailBody: "%(username) is requesting delete their account.",
  accountDeletionRequestEmailSubject: "omegaup account deletion request",
  activityReport: "Activity report",
  activityReportDuplicatesForOriginsDescription: "Addresses with more than one account",
  activityReportDuplicatesForUsersDescription: "Accounts with more than one address",
  activityReportEvent: "Event",
  activityReportNoDuplicatesForOrigins: "There are no addresses with more than one account",
  activityReportNoDuplicatesForUsers: "There are no accounts with more than one address",
  activityReportOrigin: "Origin",
  activityReportOrigins: "Origins",
  activityReportReport: "Report",
  activityReportSummaryContest: "This is a report of the activity that happened within this contest. In order to protect contestants' privacy, their IP addresses have been obfuscated using a perfect hash. That means that there is a one-to-one correspondence between IP addresses and Origin IDs.",
  activityReportSummaryCourse: "This is a report of the activity that happened within this course. In order to protect participants' privacy, their IP addresses have been obfuscated using a perfect hash. That means that there is a one-to-one correspondence between IP addresses and Origin IDs.",
  activityReportUsers: "Account name",
  addContestUsernameAndPassword: "If you participated in a contest and you were given a new account, add it here to link it to your main account.",
  addUsersMultipleOrSingleUser: "Add single or multiple accounts",
  addUsersToReviewerGroup: "Click to add an account to the list of reviewers.",
  adminAdded: "Admin successfully added.",
  adminRemoved: "Admin successfully removed.",
  adminSupportEmailUpdatedSuccessfully: "Email updated successfully",
  adminSupportPageNotFound: "Page not found",
  adminSupportTypeNewEmail: "Type new email",
  admissionModeManualOnly: "Manual only (Add the names of your students' accounts)",
  admissionModePublic: "Public (Students enroll just with the course link)",
  admissionModeShareURL: "Share URL (Students enroll from the URL)",
  aliasAlreadyInUse: "Alias \"%(alias)\" already exists. Please choose a different name.",
  aliasInUse: "alias already exists. Please choose a different alias.",
  allowedSolutionsLimitReached: "You have reached the limit of allowed solutions",
  apiNotFound: "Requested API endpoint not found.",
  apiTokenAdd: "Add API token",
  apiTokenDescription: "If you want to use the omegaup API, you can create an API token, each API token can make up to 1000 requests per hour and you can have up to 5 API tokens.",
  apiTokenLastTimeUsed: "Last time used",
  apiTokenLimit: "Limit",
  apiTokenLimitExceeded: "Maximum number of API tokens exceeded.",
  apiTokenName: "Token name",
  apiTokenNameAlreadyInUse: "API token names must be unique",
  apiTokenRateLimitExceeded: "Maximum number of API requests exceeded. Please try again later.",
  apiTokenRemaining: "Remaining requests",
  apiTokenResetTime: "Reset time",
  apiTokenRevoke: "Revoke API token",
  apiTokenSuccessfullyCreated: "Token successfully created, copy the token since it will be displayed only once: <span><code>%(token)</code></span>",
  apiTokenSuccessfullyRevoked: "Token successfully revoked",
  apiTokenTimestamp: "Timestamp",
  apiUnexpectedError: "An unexpected error occurred. Please try again later or contact support if the problem persists.",
  arbitrateRequestAcceptSuccessfully: "The request has been successfully approved",
  arbitrateRequestDenySuccessfully: "The request has been successfully denied",
  arenaClarificationCreate: "Type your clarification here:",
  arenaClarificationMaxLength: "Max. 200 characters, do not paste your entire code.",
  arenaCommonCode: "Code",
  arenaCommonMemoryLimit: "Memory limit",
  arenaCommonOverallWallTimeLimit: "Time limit (total)",
  arenaCommonTimeLimit: "Time limit (case)",
  arenaContestEndedUsePractice: "This contest has ended. To continue sending solutions please use our Practice Mode by clicking here.",
  arenaContestHasAlreadyStarted: "This contest has already started",
  arenaContestMultipleTabsDetected: "You already have this contest open in another tab. Please close this tab and return to the original one.",
  arenaContestNotOpened: "You need to open the problemset in non-admin mode to make submissions.",
  arenaContestOrganizer: "Organizer",
  arenaContestPracticeOriginalRunsText: "To see the runs from the original contest, click [here](/arena/%(contestAlias)/#runs)",
  arenaContestPracticeOriginalScoreboardText: "To see the original scoreboard, click [here](/arena/%(contestAlias)/#ranking)",
  arenaContestProblemAdded: "Problem **%(problemAlias)** was **added**.",
  arenaContestProblemChangeLog: "Problem Change Log",
  arenaContestProblemModified: "Problem **%(problemAlias)** was **updated**.",
  arenaContestProblemModifiedRefresh: "Contest update: Problem \"%(problemAlias)\" has been updated. Please refresh the page.",
  arenaContestProblemRemoved: "Problem **%(problemAlias)** was **removed**.",
  arenaContestProblemUpdateAdded: "Contest update: Problem \"%(problemAlias)\" has been added to this contest.",
  arenaContestProblemUpdateRemoved: "Contest update: Problem \"%(problemAlias)\" has been removed from this contest.",
  arenaContestWindowLength: "Time to solve all problems",
  arenaCourseAllContent: "All content",
  arenaCourseAssignmentHasAlreadyStarted: "This content has already started",
  arenaCourseAssignmentWillBeginIn: "This content will begin in %(time)",
  arenaCourseProblemTitle: "%(letter). %(title)",
  arenaPageRecommendedContestsText: "To show your contest in the Recommended Contests list, contact soporte@omegaup.com.",
  arenaPageTitle: "omegaUp Arena",
  arenaPracticeEndtime: "End time",
  arenaPracticeScoreboardCutoff: "Scoreboard cutoff time",
  arenaPracticeStartTime: "Start time",
  arenaRunSubmitEmptyCode: "Can't submit empty code",
  arenaRunSubmitFilename: "Filename your code will be saved as: ",
  arenaRunSubmitFilesize: "The file size limit for uploaded files is %(limit)",
  arenaRunSubmitMissingLanguage: "You must choose a language",
  arenaRunSubmitPaste: "Paste your program's code here",
  arenaRunSubmitUpload: "Or upload the file",
  arenaRunSubmitWaitBetweenUploads: "You have to wait %(submissionGap) seconds before you can make another submission to this problem",
  arenaRunsActions: "Actions",
  arenaRunsActionsDetails: "Details",
  arenaRunsActionsDisqualified: "Disqualified",
  arenaRunsActionsDisqualifyByGUID: "Disqualify submission",
  arenaRunsActionsDisqualifyByProblem: "Disqualify all the user submissions for this problem",
  arenaRunsActionsDisqualifyByUser: "Disqualify all the user submissions for this contest",
  arenaRunsActionsRejudge: "Rejudge",
  arenaRunsActionsRequalify: "Requalify",
  arrayEditTitle: "Array editor",
  arrayModalBack: "Back",
  arrayModalDistinctValues: "Distinct values",
  arrayModalGenerate: "Generate",
  arrayModalGeneratedArray: "Generated array",
  arrayModalMaximum: "Maximum",
  arrayModalMinimum: "Minimum",
  arrayModalSave: "Save",
  arrayModalSize: "Size",
  assignmentCardDueDate: "Due date: %(time)",
  assignmentCardLessons: "%(lessonCount) lessons",
  assignmentCardProblems: "%(problemCount) problems",
  assignmentCardStart: "Start",
  assignmentNotFound: "Content not found",
  assignmentNotStarted: "The assignment has not started yet",
  assignmentRemoveAlreadyHasRuns: "Content can't be removed once a solution has been judged.",
  authorRank: "Author rank",
  authorRankRangeHeader: "Contributors with more score (%(lowCount) to %(highCount))",
  authorRankUnranked: "Unranked author",
  badgeAssignationTimeMessage: "Date you got this badge",
  badgeFirstAssignationMessage: "The first time this badge was assigned",
  badgeNotAssignedMessage: "You have not got this badge yet",
  badgeNotExist: "The provided badge doesn't exist.",
  badgeOwnersMessage: "Coders who have received this badge",
  badge_100solvedProblems_description: "User has solved 100 or more problems.",
  badge_100solvedProblems_name: "100 solved Problems",
  badge_15dayStreak_description: "User has maintained a streak of 15 consecutive days.",
  badge_15dayStreak_name: "15-day streak",
  badge_30dayStreak_description: "User has maintained a streak of 30 consecutive days.",
  badge_30dayStreak_name: "30-day streak",
  badge_500score_description: "User has achieved a score equal to or greater than 500.",
  badge_500score_name: "500 score",
  badge_7dayStreak_description: "User has maintained a streak of 7 consecutive days.",
  badge_7dayStreak_name: "7-day streak",
  badge_christmasProblem2021_description: "The user has participated in the A Problem for Christmas 2021 Contest by submitting original Christmas-themed problems.",
  badge_christmasProblem2021_name: "Christmas Problem 2021",
  badge_coderOfTheMonth_description: "User has been Coder of The Month at least once.",
  badge_coderOfTheMonth_name: "Coder Of The Month",
  badge_contestManager_description: "User has managed at least one contest.",
  badge_contestManager_name: "Contest Manager",
  badge_cppCourseGraduate_description: "The user has solved more than 60% of C++ course.",
  badge_cppCourseGraduate_name: "C++ Course Graduate",
  badge_cppExpert_description: "The user has solved more than 10 problems in C++.",
  badge_cppExpert_name: "C++ Expert User",
  badge_feedbackProvider_description: "User has provided feedback for at least one problem.",
  badge_feedbackProvider_name: "Feedback Provider",
  badge_introToAlgorithms2CourseGraduate_description: "The user has solved more than 70% of Introduction to Algorithms II course.",
  badge_introToAlgorithms2CourseGraduate_name: "Introduction to Algorithms II Course Graduate",
  badge_introToAlgorithmsCourseGraduate_description: "The user has solved more than 70% of Introduction to Algorithms I course.",
  badge_introToAlgorithmsCourseGraduate_name: "Introduction to Algorithms I Course Graduate",
  badge_javaExpert_description: "The user has solved more than 10 problems in Java.",
  badge_javaExpert_name: "Java Expert User",
  badge_karelExpert_description: "The user has solved more than 10 problems in Karel.",
  badge_karelExpert_name: "Karel Expert User",
  badge_legacyUser_description: "User has made a submission for three years in a row.",
  badge_legacyUser_name: "Historical Trajectory",
  badge_pascalExpert_description: "The user has solved more than 10 problems in Pascal.",
  badge_pascalExpert_name: "Pascal Expert User",
  badge_problemOfTheWeekWithOmegaUp_description: "The user has solved one problem of Solving Problems in omegaUp course.",
  badge_problemOfTheWeekWithOmegaUp_name: "Problem of the Week with omegaUp",
  badge_problemSetter_description: "User has created at least one problem.",
  badge_problemSetter_name: "Problem Setter",
  badge_pythonCourseGraduate_description: "The user has solved more than 90% of Introduction to Python course.",
  badge_pythonCourseGraduate_name: "Introduction to Python Course Graduate",
  badge_pythonExpert_description: "The user has solved more than 10 problems in Python.",
  badge_pythonExpert_name: "Python Expert User",
  badge_updatedUser_description: "The user has completed the information in his profile.",
  badge_updatedUser_name: "Updated Profile",
  badge_virtualContestManager_description: "User has managed at least one virtual contest.",
  badge_virtualContestManager_name: "Virtual Contest Manager",
  banProblemFormComments: "Additional comments to the problemsetter",
  banProblemFormQuestion: "Why will this problem be banned?",
  bannerLastDayToVerifyAccount: "Attention! Only 1 day left for your father or guardian to approve your account. Otherwise, your account will be deleted.",
  bannerVerifyAccount: "It is necessary for your father or guardian to approve your account within %(days) days. Otherwise, your account will be deleted.",
  banningDeclinedByReviewer: "Banning declined by reviewer.",
  banningProblemDueToReport: "Banning problem due to account report.",
  birthdayInTheFuture: "You are not old enough to use omegaUp",
  bookmarkedProblems: "Bookmarked Problems",
  bookmarkedProblemsDesc: "Problems you saved for later",
  bulkOperationError: "There was an error executing the operation",
  bulkUserAddError: "There was an error adding accounts. The following email addresses were not found in omegaUp:<br><br><b>%(userEmail)</b>.<br><br>However, the rest of accounts have been added successfully.",
  bulkUserAddSuccess: "Accounts successfully added!",
  buttonCreateContest: "Create a contest",
  buttonCreateProblem: "Create a problem",
  buttonGoToContests: "Go to contests",
  buttonGoToCourses: "Go to courses",
  buttonGoToProblems: "Go to problems",
  cannotAddProb: "Cannot add problem. You are not a contest admin.",
  cannotEditUngroupedGroup: "It is not possible to edit an ungrouped group",
  cannotRemoveProblem: "Cannot remove the problem. You are not a contest admin.",
  cannotRemoveProblemWithSubmissions: "You cannot remove a problem that already has submissions",
  carouselActive: "Active",
  carouselArchive: "Archive",
  carouselButtonTitle: "Button title",
  carouselCreate: "Create",
  carouselCreateNew: "Create new carousel item",
  carouselDeleteConfirm: "Archive carousel item",
  carouselDeleteMessage: "Are you sure you want to archive this carousel item?",
  carouselEditItem: "Edit carousel item",
  carouselExcerpt: "Excerpt",
  carouselExpirationDate: "Expiration date",
  carouselExpirationDateHint: "Leave empty for no expiration",
  carouselExpire: "Expired",
  carouselImageUrl: "Image URL",
  carouselInactive: "Inactive",
  carouselItemArchived: "Carousel item archived successfully",
  carouselItemCreated: "Carousel item created successfully",
  carouselItemNotFound: "Carousel item not found",
  carouselItemUpdated: "Carousel item updated successfully",
  carouselLink: "Link",
  carouselNoExpiration: "No expiration",
  carouselNoImage: "No image",
  carouselNoItems: "No carousel items found",
  carouselStatusActive: "Active",
  carouselStatusAll: "All",
  carouselStatusArchived: "Archived",
  carouselUpdate: "Update",
  caseAlreadyExists: "A test case with that name already exists",
  caseEditTitle: "Edit case",
  caseModalBack: "Back",
  caseModalSave: "Save",
  caseSelectorAddCase: "Add case",
  caseSelectorCaseName: "Case name",
  caseSelectorCaseWeight: "Case weight",
  cdpNotFound: "The CDP file was not found",
  certificateDetailsBody: "Please send us an email to [certificates@omegaup.com](mailto:certificates@omegaup.com?subject=Verify%20certificate%20%(uuid)) to verify a certificate. Make sure to include the ID of the certificate (%(uuid)) in the subject.",
  certificateDetailsTitle: "Certificate verification process",
  certificateListMineActions: "Actions",
  certificateListMineCertificatesEmpty: "There are no certificates",
  certificateListMineCoderOfTheMonth: "Coder of the month",
  certificateListMineCoderOfTheMonthFemale: "Coder of the month for her",
  certificateListMineContest: "Contest \"%(contest_title)\"",
  certificateListMineCopyToClipboard: "Copy verification link",
  certificateListMineCourse: "Course \"%(course_name)\"",
  certificateListMineDate: "Date",
  certificateListMineDownload: "Download certificate",
  certificateListMineFileDownloaded: "The certificate has been downloaded",
  certificateListMineLinkCopiedToClipboard: "The verification link was copied",
  certificateListMineReason: "Reason",
  certificateListMineTitle: "My Certificates",
  certificateListMineVerificationLink: "Verification link",
  certificateNotFound: "Certificate not found",
  certificatePdfCoderOfTheMonthDescription: "for the performance in the month of %(month_name) by obtaining the highest score on the omegaUp.com platform",
  certificatePdfCoderOfTheMonthFemaleTitle: "Coder of the month for her",
  certificatePdfCoderOfTheMonthTitle: "Coder of the month",
  certificatePdfContestDescription: "for the participation in the \"%(contest_title)\" contest held on the omegaUp.com platform",
  certificatePdfContestParticipation: "Participation",
  certificatePdfContestPlaceNd: "nd place",
  certificatePdfContestPlaceRd: "rd place",
  certificatePdfContestPlaceSt: "st place",
  certificatePdfContestPlaceTh: "th place",
  certificatePdfCourseDescription: "for completing the \"%(course_name)\" course on the omegaUp.com platform",
  certificatePdfCourseTitle: "Graduation",
  certificatePdfDirector: "Executive Director",
  certificatePdfGrantsRecognition: "Grants recognition of",
  certificatePdfHeader: "Code a better future. For everyone.",
  certificatePdfMonth1: "January",
  certificatePdfMonth10: "October",
  certificatePdfMonth11: "November",
  certificatePdfMonth12: "December",
  certificatePdfMonth2: "February",
  certificatePdfMonth3: "March",
  certificatePdfMonth4: "April",
  certificatePdfMonth5: "May",
  certificatePdfMonth6: "June",
  certificatePdfMonth7: "July",
  certificatePdfMonth8: "August",
  certificatePdfMonth9: "September",
  certificatePdfPerson: "to the person",
  certificatePdfPlaceAndDate: "Bellevue, Washington on %(month) %(day), %(year)",
  certificatePdfVerificationCode: "Verification code: %(verification_code)",
  certificatePdfVerificationLink: "Verification link: https://omegaup.com/cert/%(verification_code)/",
  certificateValidationCertifyValidity: "omegaUp certifies the validity of the following certificate",
  certificateValidationEnteredCode: "Entered code: ",
  certificateValidationInvalid: "Invalid",
  certificateValidationNotFound1: "No certificate with the code ",
  certificateValidationNotFound2: " was found in the database. If you think this is an error please contact us at hello@omegaup.com.",
  certificateValidationStatus: "Status: ",
  certificateValidationTitle: "Verify Certificate",
  clarificationContest: "Contest:",
  clarificationEmailBody: "<p>Howdy!</p><p><strong><a href=\"https://omegaup.com/profile/%(user_name)\">%(user_name)</a></strong> has requested a clarification for the problem <strong><a href=\"https://omegaup.com/arena/problem/%(problem_alias)\">%(problem_name)</a></strong>:</p><p><blockquote><p>%(clarification_body)</p></blockquote><p>To answer it, please visit the following link: <a href=\"%(url)\">%(url)</a>.</p><p>Thanks!,<br/>omegaUp</p>",
  clarificationEmailSubject: "[omegaUp] New clarification for problem %(problem_name)",
  clarificationHomework: "Homework:",
  clarificationInfo: "Info",
  clarificationNotFound: "Clarification not found",
  clarificationProblem: "Problem:",
  clarificationTime: "Date and Time:",
  clarificationUpdateAnswer: "Update answer",
  clarificationsAskedBy: "Asked by:",
  clarificationsEmpty: "No clarifications yet",
  clarificationsOnBehalf: "%(author) (on behalf %(receiver))",
  clarificationsRangeHeader: "Clarifications (from %(lowCount) to %(highCount))",
  codeTemplatesDescription: "Save your own starting code for each language. The submission editor will load it automatically whenever you choose that language.",
  codeTemplatesRestoreDefault: "Restore default template",
  codeTemplatesRestoreSuccess: "The code template was restored to the default.",
  codeTemplatesSaveSuccess: "The code template was saved.",
  coderOfTheMonth: "Coder of the Month Overall",
  coderOfTheMonthAlreadySelected: "Coder of the month has been previously selected",
  coderOfTheMonthCanBeChosenManually: "Remember that you can choose the winners of Coder of the Month for both categories in the [Coder of the Month](https://omegaup.com/coderofthemonth/) section and the [Coder of the Month for women](https://omegaup.com/coderofthemonth/female/) section.",
  coderOfTheMonthChooseAsCoder: "Choose as coder of the month",
  coderOfTheMonthFemale: "Coder of the Month for Her",
  coderOfTheMonthFemaleChooseAsCoder: "Choose as female coder of the month",
  coderOfTheMonthFemaleSelectedSuccessfully: "Female coder of the month has been selected successfully!",
  coderOfTheMonthFullList: "See full list",
  coderOfTheMonthIsNotInPeriodToBeChosen: "Coder of the month is not in the period to be chosen",
  coderOfTheMonthNotFound: "Coder of the month not found.",
  coderOfTheMonthNotice: "Hi %(username)! Congratulations for winning the Coder of the Month!",
  coderOfTheMonthSelectedSuccessfully: "Coder of the month has been selected successfully!",
  coderOfTheMonthSystemInMaintainance: "The Coder of the Month system is under maintenance.\n\nWe will be back soon.",
  codersOfTheMonth: "Coders of the Month",
  codersOfTheMonthCountry: "Country / Region",
  codersOfTheMonthDate: "Date",
  codersOfTheMonthFemale: "Female coders of the Month",
  codersOfTheMonthFemaleListCandidate: "List of candidates to female coder of the month",
  codersOfTheMonthFemaleRank: "Top 100 coders of the previous month",
  codersOfTheMonthListCandidate: "List of candidates to coder of the month",
  codersOfTheMonthRank: "Top 100 coders of the previous month",
  codersOfTheMonthUser: "Coder",
  collecionOtherTags: "Other tags",
  collectionHideFilters: "Hide filters",
  collectionShowFilters: "Show filters",
  collectionTitle: "Problem Collections",
  compareButton: "Compare",
  compareDescription: "Compare the profiles and statistics of two users",
  compareEnterUsername: "Enter username",
  compareUser1Label: "User 1",
  compareUser2Label: "User 2",
  compareUserNotFound: "User not found",
  compareUsersTitle: "Compare Users",
  compareVsMe: "Compare vs me",
  contentCreationRateLimitExceeded: "You have exceeded the maximum number of allowed creations per hour. Please try again later.",
  contentCreator: "Contributor",
  contentOrderUpdated: "Content's order has been updated",
  contestAddUserContestant: "Contestant",
  contestAddgroupAddGroup: "Add group",
  contestAddlectureLectureName: "Lecture",
  contestAddlectureLecturePoints: "Points this lecture is worth",
  contestAddproblemChooseVersion: "Version",
  contestAddproblemContestOrder: "Contest order",
  contestAddproblemLatestVersion: "Latest version",
  contestAddproblemOtherVersion: "Other version",
  contestAddproblemProblemConfirmRemove: "Do you really want to remove \"%(problem)\"?",
  contestAddproblemProblemName: "Problem",
  contestAddproblemProblemOrder: "Order",
  contestAddproblemProblemPoints: "Points this problem is worth",
  contestAddproblemProblemRemove: "Remove",
  contestAddproblemTooManyProblems: "This contest has too many problems, so it is not possible to add more",
  contestAdduserAddContestant: "Contestants",
  contestAdduserAddUsers: "Add accounts",
  contestAdduserRegisteredUserDelete: "Remove",
  contestAdduserRegisteredUserTime: "First access time",
  contestAdmissionModeDescription: "Select contest admission mode. There are three different modalities:\n\n- **Private:** Contest is only visible to coders who have been explicitly invited.\n\n- **Registration/open:** Anyone can register, only people admitted by admins have access.\n\n- **Public:** Anyone can participate.",
  contestAndProblemPrintButtonDesc: "Print",
  contestBasicInformationNeeded: "To join the contest you must fill in your basic information. Go to [My profile](/profile/#edit-basic-information)",
  contestButtonEnter: "Enter",
  contestButtonScoreboard: "Scoreboard",
  contestButtonSeeDetails: "See details",
  contestCanNotChangeToContestForTeams: "A normal contest cannot be changed to a contest for teams",
  contestCertificatesConfirmGenerate: "Are you sure you want to generate the certificates?, once the certificates are generated they cannot be modified. Make sure the scoreboard is unfrozen.",
  contestCertificatesCurrentContestError: "Certificates cannot be generated because the contest has not ended yet.",
  contestCertificatesCutoff: "Certificates cutoff",
  contestCertificatesCutoffHelp: "The number of contestants in first positions to be awarded with special certificates. The rest of the contestants will receive participation certificates that do not mention where they ended up.",
  contestCertificatesError: "There was an error generating the certificates.",
  contestCertificatesGenerate: "Generate certificates",
  contestCertificatesGenerateSuccessfully: "Certificates generated successfully.",
  contestDetailsGoToContest: "Go to contest",
  contestDownloadListOfUsersInContest: "Download list of coders in the contest",
  contestDuration: "Duration: %(duration)",
  contestDurationDay: "1 day",
  contestDurationDays: "%(N) days",
  contestDurationHour: "1 hour",
  contestDurationHours: "%(N) hours",
  contestDurationMinute: "1 minute",
  contestDurationMinutes: "%(N) minutes",
  contestEdit: "Edit",
  contestEditAddProblemSearchByAlias: "Alias",
  contestEditAddProblemSearchByAll: "All",
  contestEditAddProblemSearchById: "Id",
  contestEditAddProblemSearchByTitle: "Title",
  contestEditAddProblems: "Problems",
  contestEditAdministrativeLinks: "Administrative Links",
  contestEditArchive: "Archive",
  contestEditArchiveConfirmText: "Are you sure you want to perform this action?",
  contestEditArchiveContest: "Archive contest",
  contestEditArchiveHelpText: "When archiving a contest, it will no longer appear in all the lists. The only way to access it is through its URL or from the list of \"My contests\", in the \"Archived contests\" tab. This action can be undone.",
  contestEditArchivedSuccess: "Contest archived successfully.",
  contestEditCannotReplaceTeamsGroupWithSubmissions: "You cannot replace the teams group in a contest that already has submissions",
  contestEditCatLanguageAddedWarning: "\"cat\" was added to contest languages because the added problem requires it",
  contestEditCertificates: "Certificates",
  contestEditContestClonedSuccessfully: "Contest was cloned successfully",
  contestEditContestEdited: "Your contest has been edited! [View contest](/arena/%(alias)/)",
  contestEditContestLinkCopiedToClipboard: "Contest link copied to clipboard successfully",
  contestEditCopyContestLink: "Copy contest link",
  contestEditRegisteredAdminDelete: "Remove",
  contestEditRegisteredAdminRole: "Role",
  contestEditRegisteredAdminUsername: "Coder",
  contestEditRegisteredGroupAdminName: "Group",
  contestEditTagDelete: "Delete",
  contestEditTagName: "Tag name",
  contestEditTeamsGroupReplace: "Replace teams group",
  contestEditTeamsGroupReplaced: "Teams group replaced successfully",
  contestEditUnarchiveContest: "Unarchive contest",
  contestEditUnarchiveHelpText: "This contest is already archived, if you want to return it back to the unarchived contests list, click in the button",
  contestEditUnarchivedSuccess: "Contest unarchived successfully",
  contestEditWithTitle: "Edit contest %(title)",
  contestEndTime: "Ends: %(endDate)",
  contestEndedAgo: "Ended %(duration) ago",
  contestEndedOn: "Ended: %(endDate)",
  contestEndsIn: "Ends in %(duration)",
  contestEnrollStatus: "Signed Up",
  contestFilterBy: "Filter by",
  contestFilterByAll: "All",
  contestFilterByRecommended: "Only recommended",
  contestFilterBySignedUp: "I am participant",
  contestForTeamsCanNotChangeToContest: "A contest for teams cannot be changed to a normal contest",
  contestGroupAdded: "Group successfully added.",
  contestGroupRemoved: "Group successfully removed.",
  contestInformationNotRequired: "Account information for this contest was not required.",
  contestIntroDifferentStarts: "Once the contest has started, its duration will be %(window_length).",
  contestIntroGoToHomePage: "Go to homepage",
  contestIntroLogout: "Logout",
  contestIntroLogoutToJoinWithRegisteredUser: "You may have received the invitation to this contest using a different account than the one currently logged in. Would you like to log out and then log in with the correct credentials?",
  contestIntroPenaltyDesc: "Each incorrect submission will be penalized with a time of %(window_length).",
  contestIntroScoreboardTimePercent: "The scoreboard will be shown live for the first %(window_length) of the contest.",
  contestIntroScoreboardTimePercentOneHundred: "The live scoreboard will be shown throughout the contest.",
  contestIntroScoreboardTimePercentZero: "The scoreboard will not be shown during the contest.",
  contestIntroSubmissionsSeparationDesc: "For each incorrect submission you must wait %(window_length) to make a new submission.",
  contestLengthTooLong: "Contests can't last more than %(max_days) days.",
  contestListArchivedContests: "Archived contests",
  contestListCurrent: "Current",
  contestListEmpty: "There are no contests that meet those characteristics",
  contestListFuture: "Future",
  contestListPast: "Past",
  contestListShowAdminContests: "Also show contests I manage",
  contestListSubmissions: "Submissions",
  contestMustBeCreatedInPrivateMode: "Contest must be created in private mode",
  contestNew: "New contest",
  contestNewForm: "IOI Style",
  contestNewFormAdmissionMode: "Admission mode",
  contestNewFormAdmissionModeDescription: "Select contest admission mode. There are three different modalities:<br /><ul><li>Private: Contest is only visible to coders who have been explicitly invited.</li><li>Registration/open: Anyone can register, only people admitted by admins have access.</li><li>Public: Anyone can participate.</li></ul>",
  contestNewFormAliasInvalid: "alias can only contain letters, numbers, and hyphens",
  contestNewFormBasicInfo: "Basic Information",
  contestNewFormBasicInformationRequired: "Basic information is required",
  contestNewFormBasicInformationRequiredDesc: "If activated, all contestants must have registred their basic information to join the contest (country, state, school)",
  contestNewFormByContests: "In case of a tie, it will be broken by time. Time will be measured between the moment that the contest started and the moment each problem was solved.",
  contestNewFormByProblem: "In case of a tie, it will be broken by time. Time will be measured between the moment that each problem was opened and the moment it was solved.",
  contestNewFormByRuntime: "In case of a tie, it will be broken by program runtime (milliseconds).",
  contestNewFormConacupStyle: "CONACUP style",
  contestNewFormDecayFactorRange: "0.0 to 1.0",
  contestNewFormDecrementFactor: "The score of each problem will be given by the formula: (1 - (%(window_length) + %(window_length) * TT^2 / (10 * PT^2 + TT^2), where PT is the penalty of the submission in minutes and TT the total length of the contest in minutes.",
  contestNewFormDescription: "Contest description",
  contestNewFormDescriptionRequired: "Description is required",
  contestNewFormDifferentStarts: "Different starts",
  contestNewFormDifferentStartsDesc: "If activated, indicate how much time in minutes the coder has to enter the contest and submit solutions from the moment that the coder enters the contest on the platform. The value must be less than the difference in minutes of the contest duration. If it's not activated, you can only participate between the start time and the end time of the contest.",
  contestNewFormEndDate: "End date",
  contestNewFormEndDateDesc: "The time and date (in local time) in which the contest will end.",
  contestNewFormFinishTimeInvalid: "End date must be after start date",
  contestNewFormForTeams: "Contest for teams",
  contestNewFormForTeamsDesc: "If activated, the contest can only be accessed by teams instead of identities. The teams have to be added to a teams group. This option is only available for new contests.",
  contestNewFormICPCStyle: "ICPC style",
  contestNewFormImmediateFeedbackDesc: "After evaluating each submission, the verdict will be shown.",
  contestNewFormImmediateSummaryFeedbackDesc: "After evaluating each submission, the summary of scores and verdicts for each group of cases will be shown.",
  contestNewFormLanguageRemoveBlockedWarning: "Cannot remove \"%(language)\" from languages because there is at least one problem that requires it",
  contestNewFormLanguages: "Set languages to the current contest",
  contestNewFormLanguagesHelp: "At least one language must be selected",
  contestNewFormLanguagesRequired: "Please select at least one language",
  contestNewFormLogistics: "Logistics (optional)",
  contestNewFormNoPenalty: "Coders with the same score will end up in a draw, regardless of the time it has taken each coder.",
  contestNewFormNumberOfContestants: "Number of contestants",
  contestNewFormNumberOfContestantsDesc: "Number of contestants allowed for every team",
  contestNewFormOmiStyle: "OMI - IOI Style",
  contestNewFormPenaltyDesc: "Integer amount of minutes to penalize an incorrect submission.",
  contestNewFormPenaltyInvalid: "Penalty must be 0 or greater",
  contestNewFormPenaltyType: "Penalty type",
  contestNewFormPenaltyTypeDesc: "Indicates how the submission penalty is calculated: minutes since the beginning of the contest, minutes since the problem was opened, or program execution time (milliseconds).",
  contestNewFormPointDecrementFactor: "Score Decrement Factor",
  contestNewFormPointDecrementFactorDesc: "A number between 0 and 1, inclusive. If the number is different from 0, the score awarded for a correct submission will decay as time passes, according to the following formula: (1 - points_decay_factor) + points_decay_factor * TT^2 / (10 * PT^2 + TT^2), where PT is the penalty of the submission in minutes and TT the total length of the contest in minutes.",
  contestNewFormPointsDecayFactorInvalid: "Points decay factor must be between 0 and 1",
  contestNewFormPresetOverwriteWarning: "Applying this preset will overwrite your current form values. Continue?",
  contestNewFormPresetOverwriteWarningModalTitle: "Change preset",
  contestNewFormPrivacy: "Privacy (optional)",
  contestNewFormProcessing: "Processing...",
  contestNewFormRecommended: "Recommended Contest",
  contestNewFormRecommendedTextAdmin: "Enable this option if you want your contest to appear in the Recommended Contests list.",
  contestNewFormRecommendedTextNonAdmin: "To show your contest in the Recommended Contests list, contact soporte@omegaup.com.",
  contestNewFormScheduleContest: "Schedule contest",
  contestNewFormScheduleVirtualContest: "Schedule virtual contest",
  contestNewFormScoreMode: "Score mode",
  contestNewFormScoreModeAllOrNothing: "All or nothing",
  contestNewFormScoreModeDesc: "Choose \"All or nothing\" if you want the contestants to have to solve all the cases of the problems to get points. Choose \"Partial\" if you want contestants to the get points corresponding to the submission that solved the most test cases. Choose \"Max per group\" if you want the contestants to obtain the points corresponding to all the cases that they managed to solve with any of their submissions.",
  contestNewFormScoreModeMaxPerGroup: "Max per group",
  contestNewFormScoreModePartial: "Partial",
  contestNewFormScoreboardAtContestEnd: "The scoreboard will be visible at the end of the contest.",
  contestNewFormScoreboardAtEnd: "Show scoreboard at the end of the contest",
  contestNewFormScoreboardAtEndDesc: "Show the complete scoreboard at the end of the contest.",
  contestNewFormScoreboardInvalid: "Scoreboard percentage must be between 0 and 100",
  contestNewFormScoreboardPercentRange: "0-100%",
  contestNewFormScoreboardTimePercent: "Visible scoreboard time (%)",
  contestNewFormScoreboardTimePercentDesc: "Integer between 0 and 100, indicating the percentage of the contest's total time where the scoreboard will be visible.",
  contestNewFormScoringRules: "Scoring Rules (optional)",
  contestNewFormShortTitleAlias: "Short title (alias)",
  contestNewFormShortTitleAliasDesc: "The alias is used to construct the contest's URL (e.g. CodingCup2023, OFMI2024, CopaCentroAmericana2024, etc.) It cannot contain spaces.",
  contestNewFormShortTitleRequired: "Contest alias is required",
  contestNewFormStartDate: "Start date",
  contestNewFormStartDateDesc: "The time and date (in local time) in which the contest will begin",
  contestNewFormSubmissionsGapHelp: "Minutes between submissions",
  contestNewFormSubmissionsGapInvalid: "Submissions gap must be 0 or greater",
  contestNewFormSubmissionsSeparation: "Submission time window",
  contestNewFormSubmissionsSeparationDesc: "Time in minutes that must pass before a contestant can send a new submission for the same problem after sending one (1 minute minimum).",
  contestNewFormTeamsGroupLocked: "This team group cannot be changed after the contest has started",
  contestNewFormTeamsGroupRequired: "Teams group must be selected for team contests",
  contestNewFormTitlePlaceholderConacupStyle: "**CONACUP Style applied. Set your title here**",
  contestNewFormTitlePlaceholderICPCStyle: "**ICPC Style applied. Set your title here**",
  contestNewFormTitlePlaceholderIoiStyle: "**IOI Style applied. Set your title here**",
  contestNewFormTitlePlaceholderOmiStyle: "**OMI Style applied. Set your title here**",
  contestNewFormTitleRequired: "Contest title is required",
  contestNewFormUpdateContest: "Update contest",
  contestNewFormUserInformationRequired: "Request access to participant information",
  contestNewFormUserInformationRequiredDesc: "Choose \"Optional\" to allow each coder to decide whether to share their personal information and participate independently. Otherwise, choose \"Required\", but consider that some people may choose not to participate.",
  contestNewFormWindowLengthInvalid: "Window length must be greater than 0",
  contestNewFormWindowLengthPlaceholder: "Minutes",
  contestNewInvalidStartTime: "The start time must be before the end time.",
  contestNotFound: "Contest not found.",
  contestNotRegistered: "You are not registered for this contest.",
  contestNotStarted: "Contest has not started yet.",
  contestOrderBy: "Order by",
  contestOrderByContestants: "Contestants",
  contestOrderByDuration: "Duration",
  contestOrderByEnds: "Ends",
  contestOrderByOrganizer: "Organizer",
  contestOrderBySignedUp: "Signed up",
  contestOrderByTitle: "Name",
  contestParticipant: "Coder",
  contestPracticeMode: "Practice",
  contestPrintableVersion: "Printable version",
  contestPublicForTeamsNotSupported: "Public contests for teams are not supported yet",
  contestPublicRequiresProblem: "Public contests require at least one problem. Please add a problem to this contest before marking it as public.",
  contestRegistrationPreAcceptedDescription: "This account has been explicitly invited to the contest",
  contestReport: "Contest Report: %(contest_alias)",
  contestReportProblemWithAlias: "Problem: %(alias)",
  contestReportProblemWithPoints: "Points: %(points)",
  contestReportTotalPoints: "Total: %(total_points)",
  contestReportUsername: "Account name: %(username)",
  contestScoreboardAdminLink: "Admin scoreboard link",
  contestScoreboardDownloadCsvFile: "Download scoreboard (.csv)",
  contestScoreboardLink: "Scoreboard link",
  contestScoreboardMergeChoseContests: "Choose the contests",
  contestStartTime: "Starts: %(startDate)",
  contestStartedTime: "Started: %(startedDate)",
  contestStartsIn: "Starts in %(duration)",
  contestStartsOn: "Starts: %(startDate)",
  contestUpdateAlreadyHasRuns: "Length of a contest can't be changed once a solution has been judged.",
  contestVirtualMode: "Virtual",
  contestWillBeginIn: "This contest will begin in %(time)",
  contestsCreate: "Create Contest",
  contestsCreateDesc: "Host your own competition",
  contestsJoinScoreboards: "Merge Scoreboards",
  contestsJoinScoreboardsDesc: "Merge scoreboards from several contests",
  contestsListLoading: "Loading...",
  contestsListShowMore: "Show more contests",
  couldNotCreateTemporaryFile: "Could not create temporary file",
  countryNotSet: "Country not set",
  courseActionScoreboard: "Scoreboard",
  courseAddContent: "Add content",
  courseAddLecturesAdd: "Add lectures",
  courseAddLecturesAddAssignmentDesc: "Add all the lectures that you want to include. These lectures will be stored after you press the Add content button. If you do not want to decide which lectures to use right now, you can add them later.",
  courseAddLecturesAssignmentsDesc: "Type the name of the lecture to be added.",
  courseAddLecturesEditAssignmentDesc: "Add all the lectures that you want to include. These lectures will be stored by pressing the Add lecture button.",
  courseAddProblemsAdd: "Add problems",
  courseAddProblemsAddAssignmentDesc: "Add all the problems that you want to include. These problems will be stored after you press the Add content button. If you do not want to decide which problems to use right now, you can add them later.",
  courseAddProblemsAssignmentsDesc: "Type the name of the problem to be added.",
  courseAddProblemsEditAssignmentDesc: "Add all the problems that you want to include. These problems will be stored by pressing the Add problem button.",
  courseArchiveConfirmText: "Are you sure you want to perform this action?",
  courseArchiveHelpText: "When archiving a course, it will no longer appear in all the lists. The only way to access it is through its URL or from the list of \"Courses I manage\", in the \"Archived courses\" tab. This action can be undone.",
  courseArchivedSuccess: "Course archived successfully.",
  courseAssignmentAdded: "Content added successfully!",
  courseAssignmentConfirmDelete: "Do you really want to delete %(assignment)?",
  courseAssignmentDelete: "Delete content",
  courseAssignmentDeleted: "Content deleted successfully!",
  courseAssignmentEdit: "Edit content",
  courseAssignmentEndDateBeforeCourseStartDate: "The end date is previous to the course start date",
  courseAssignmentLectureAdded: "Lecture added successfully.",
  courseAssignmentLectureRemove: "Remove lecture",
  courseAssignmentLectureRemoved: "Lecture removed successfully.",
  courseAssignmentLectureReorder: "Reorder lectures",
  courseAssignmentLecturesEmpty: "No lectures",
  courseAssignmentNewFormEndDateDesc: "Time and date (in local time) in which the assignment will end.",
  courseAssignmentNewFormSchedule: "Add content",
  courseAssignmentNewFormShortTitleAliasDesc: "The alias is used to construct the URL (examples: HOMEWORK1, FINALTEST)",
  courseAssignmentNewFormStartDateDesc: "Time and date (in local time) in which it will start.",
  courseAssignmentNewFormUpdate: "Update content",
  courseAssignmentProblemAdded: "Problem added successfully.",
  courseAssignmentProblemConfirmRemove: "Do you really want to remove %(problem)?",
  courseAssignmentProblemRemove: "Remove problem",
  courseAssignmentProblemRemoved: "Problem removed successfully.",
  courseAssignmentProblemReorder: "Reorder problems",
  courseAssignmentProblemRunsEmpty: "No runs",
  courseAssignmentProblemsEmpty: "No problems",
  courseAssignmentReorder: "Reorder content from course",
  courseAssignmentStartDateBeforeCourseStartDate: "The start date is previous to the course start date",
  courseAssignmentTitle: "%(courseName) - %(assignmentName)",
  courseAssignmentUpdated: "Content updated successfully!",
  courseBasicInformationNeeded: "To join the course you must fill in your basic information. [Go to my profile](/profile/#edit-basic-information).",
  courseCardCourseResume: "Resume",
  courseCardImpartedBy: "Imparted by: **%(school_name)**",
  courseCardMustLogIn: "You must login to see these courses.",
  courseCardProgress: "Progress:",
  courseCardPublicLevelAdvanced: "\u2605\u2605\u2605 Advanced",
  courseCardPublicLevelIntermediate: "\u2605\u2605 Intermediate",
  courseCardPublicLevelIntroductory: "\u2605 Introductory",
  courseCardsListSearch: "\ud83d\udd0d Course name",
  courseCloneCreatedBy: "Created by",
  courseCloneGenerateLinkButton: "Generate link",
  courseCloneGenerateLinkDescription: "Any person with whom you share this link can use it to clone the course for a period of 7 days",
  courseCloneGenerateLinkSuccess: "The link was successfully generated",
  courseCloneGenerateLinkTitle: "Generate clone link",
  courseContentEmpty: "No content",
  courseContentEmptyDescription: "Add content to this course to get started.",
  courseContentEmptyTitle: "No course content yet",
  courseContentNewFormTypeDesc: "The content type is used to distinguish tests from homeworks or lessons visually.",
  courseCreate: "Create Course",
  courseCreateDesc: "Teach with your own course",
  courseDetailsOverallCompletedPoints: "%(completed_points) of %(total_points) points",
  courseDetailsProgress: "Course progress",
  courseDetailsSettings: "Settings",
  courseDetailsTabContent: "Content",
  courseDetailsTabInformation: "General information",
  courseDoesNotAdmitRegistration: "Course doesn't admit student registration",
  courseDoesNotHaveUnlimitedDuration: "It is not possible to set an unlimited duration if the course is a non-unlimited duration.",
  courseEdit: "Edit course",
  courseEditAddAdminsTooltip: "Add admins using their omegaUp account name",
  courseEditAddGroupAdminsTooltip: "Add groups admins. Make sure the group exists.",
  courseEditAddGroupTeachingAssistantTooltip: "Add groups teaching assistants. Make sure the group exists.",
  courseEditAddLectures: "Add lecture",
  courseEditAddProblems: "Add problem",
  courseEditAddStudentsAdd: "Add",
  courseEditAddStudentsDescription: "Manage the students who will participate in the course",
  courseEditAddStudentsStudent: "Student",
  courseEditAddTeachingAssistants: "Add teaching assistant",
  courseEditAddTeachingAssistantsTooltip: "Add teaching assistants using their omegaUp account name",
  courseEditAdmins: "Administrators",
  courseEditAdminsEmpty: "No administrators",
  courseEditAdmissionModeDescription: "Manual: Only students who are explicitly invited can register.\nShare URL: Anyone with the link can apply to join. Additionally you can manually add the account name of each student.",
  courseEditAdmissionModeSelect: "Select course admission mode",
  courseEditArchive: "Archive",
  courseEditClone: "Clone",
  courseEditCourseClonedSuccessfully: "Your course has been cloned successfully! <a href=\"/course/%(course_alias)/edit/\">Edit course</a>",
  courseEditCourseEdited: "Your course has been edited",
  courseEditCourseEditedAndGoToCourse: "Your course has been edited! <a href=\"/course/%(alias)\">Go to course</a>",
  courseEditGoToCourse: "Go to course",
  courseEditGroupAdminsEmpty: "No admin groups",
  courseEditGroupTeachingAssistant: "Teaching assistant group",
  courseEditGroupTeachingAssistantAdded: "Teaching assistant group successfully added.",
  courseEditGroupTeachingAssistantRemoved: "Teaching assistant group successfully removed.",
  courseEditGroupTeachingAssistantsEmpty: "No teaching assistant groups",
  courseEditRequestSetRecommendedCourse: "If you are interested in having your course appear in the list of public courses, please contact [hello@omegaup.com](mailto:hello@omegaup.com) indicating the course alias for review.",
  courseEditShowInPublicCoursesList: "Show in public courses list",
  courseEditStudents: "Students",
  courseEditTeachingAssistantAddedSuccessfully: "Teaching assistant successfully added",
  courseEditTeachingAssistantRemovedSuccessfully: "Teaching assistant successfully removed",
  courseEditTeachingAssistants: "Teaching Assistant",
  courseEditTeachingAssistantsEmpty: "No teaching assistants",
  courseExamEmpty: "No exams",
  courseExtraPointsProblem: "Valid for extra points",
  courseExtraPointsProblemDesc: "The points of this problem are counted only if the course's maximum score is not reached.",
  courseExtraPointsProblemLabel: "Extra points problem",
  courseGroupNotFound: "Course group not found",
  courseHomepageStudentsSectionAlt: "Students section",
  courseHomepageStudentsSectionContent: "**Students**\n\n- Get instant feedback on their solutions.\n- Learn professional skills.\n- Access public online courses 24/7.\n",
  courseHomepageTeachersSectionAlt: "Teachers section",
  courseHomepageTeachersSectionContent: "**Professors**\n\n- Choose from more than 2000 problems for their assignments and exams in their courses.\n- Follow the student's progress in real-time.\n- Identify areas where students are struggling.\n",
  courseHomepageTitle: "Discovering and preparing the talent of Latin America",
  courseIntroImpartedBy: "Organized by",
  courseIntroLevel: "Level: %(level)",
  courseIntroWhatYouWillLearn: "What you will learn in this course",
  courseInvalidStartTime: "The start time must be before the end time.",
  courseLevelAdvanced: "Advanced",
  courseLevelAdvancedLevel: "Advanced level",
  courseLevelAllLevels: "All levels",
  courseLevelIntermediate: "Intermediate",
  courseLevelIntermediateLevel: "Intermediate level",
  courseLevelIntroductory: "Introductory",
  courseLevelIntroductoryLevel: "Introductory level",
  courseList: "Courses list",
  courseListAdminCourses: "Courses I manage",
  courseListArchivedCourses: "Archived courses",
  courseListCurrentCourses: "Current courses",
  courseListEmptyDescription: "Create your first course to start organizing lessons and students.",
  courseListEmptyTitle: "You do not have any courses yet",
  courseListPastCourses: "Past courses",
  courseListSubmissionsByGroup: "Submissions made by students of this course",
  courseListTeachingAssistantCourses: "Courses I assist",
  courseNew: "New course",
  courseNewFormBasicInformationRequired: "Basic information is required",
  courseNewFormBasicInformationRequiredDesc: "If activated, all contestants must have registred their basic information to join the course (country, state, school)",
  courseNewFormDescription: "Description",
  courseNewFormEndDate: "End date",
  courseNewFormEndDateDesc: "Time and date (in local time) in which the course will end.",
  courseNewFormLanguages: "Set languages for the current course",
  courseNewFormLanguagesRequired: "Please select at least one language",
  courseNewFormLevel: "Level",
  courseNewFormLevelDesc: "The course's difficulty level.",
  courseNewFormLevelPlaceholder: "Select a level",
  courseNewFormObjective: "Objective",
  courseNewFormObjectiveDesc: "Describe what your students will learn in this course.",
  courseNewFormScheduleCourse: "Schedule course",
  courseNewFormShortTitleAlias: "Short title (alias)",
  courseNewFormShortTitleAliasDesc: "The alias is used to construct the course URL (examples: IPNVERANO2016, ITVERINTRO2016)",
  courseNewFormShowScoreboard: "Show scoreboard",
  courseNewFormShowScoreboardDesc: "Show general scoreboard to course students.",
  courseNewFormStartDate: "Start date",
  courseNewFormStartDateDesc: "Time and date (in local time) in which the course will start.",
  courseNewFormUnlimitedDuration: "Unlimited duration",
  courseNewFormUnlimitedDurationDesc: "If activated, the finish time will be null and the course will have an unlimited duration.",
  courseNewFormUpdateCourse: "Update course",
  courseNewFormUserInformationRequired: "Request participant information",
  courseNewFormUserInformationRequiredDesc: "Enable this option to request access to the information of the participants that belong to the course in order to be contacted later. Keep in mind that the participants can choose whether they want to give access to their information or not.",
  courseNotFound: "Course not found",
  coursePrivacyConsent: "Course privacy consent",
  courseProgressGlobalScore: "Global Score",
  courseRegistrationPreAcceptedDescription: "This account has been explicitly invited to the course",
  courseRequestFeedback: "Do you have doubts? request feedback on your code!",
  courseStatisticsAverageRuns: "Average submissions",
  courseStatisticsAverageScore: "Average score",
  courseStatisticsMaximumScore: "Maximum score",
  courseStatisticsMinimumScore: "Minimum score",
  courseStatisticsScoreVariance: "Score variance",
  courseStatisticsStudentsAbove: "Students scored above 60%",
  courseStatisticsStudentsCompleted: "Students with a score equal to 100%",
  courseStatisticsStudentsScored: "Students scored at 0%",
  courseStatisticsVariance: "Variance",
  courseStatisticsVerdicts: "Verdict distribution",
  courseStudentAdded: "Student added successfully.",
  courseStudentCountLabel: "Students: %(student_count)",
  courseStudentNotInCourse: "The student was not in the course.",
  courseStudentRemoved: "Student removed successfully.",
  courseStudentSelectAssignment: "Select content",
  courseStudentSelectStudent: "Select student",
  courseStudentsEmptyDescription: "Add students to this course to start tracking their progress.",
  courseStudentsEmptyTitle: "No students enrolled yet",
  courseStudentsProgress: "Students' progress",
  courseStudentsProgressExportToSpreadsheet: "Export table as:",
  courseSubmissionNotFound: "The submission for any problem of this course has not been found",
  courseSubmissionsList: "Course submissions list",
  courseTabEnrolled: "Enrolled courses (%(course_count))",
  courseTabEnrolledUnlogged: "Enrolled courses",
  courseTabFinished: "Finished courses (%(course_count))",
  courseTabFinishedUnlogged: "Finished courses",
  courseTabPublic: "Explore courses",
  courseTabsEmptyEnrolledCourses: "You are not registered in any course",
  courseTabsEmptyFinishedCourses: "There aren't finished courses",
  courseUnarchivedSuccess: "Course unarchived successfully.",
  courseUnsavedChangesWarning: "You have unsaved changes. Are you sure you want to leave this page?",
  courseUpdateAlreadyHasRuns: "The duration can't be changed once a solution has been judged.",
  courseWithoutProblems: "Without problems",
  createContestInteractiveGuideContestTitle: "Choose the title of your contest",
  createContestInteractiveGuideDescription: "Add a description for your contest",
  createContestInteractiveGuideSchedule: "After filling out all the information, schedule the contest",
  createContestInteractiveGuideShortTitle: "Choose a short title for your contest",
  createContestInteractiveGuideStyle: "Choose from predefined contest styles",
  createContestInteractiveGuideTitle: "Create a Contest",
  createContestInteractiveGuideWelcome: "Let's create a contest",
  createCourseInteractiveGuideAskInformation: "Select if you want to request information from participants.",
  createCourseInteractiveGuideBasicInformation: "Select if basic participant information will be required.",
  createCourseInteractiveGuideDescription: "Enter a brief course description.",
  createCourseInteractiveGuideDuration: "Do you want it to have unlimited duration?",
  createCourseInteractiveGuideEndDate: "Choose the course end date.",
  createCourseInteractiveGuideLanguage: "Select the permitted programming languages.",
  createCourseInteractiveGuideLevel: "Select course level",
  createCourseInteractiveGuideName: "Choose the course name.",
  createCourseInteractiveGuideObjective: "What will be the course objective?",
  createCourseInteractiveGuideSchool: "Enter your school.",
  createCourseInteractiveGuideScoreboard: "Do you want to display the scoreboard in the course?",
  createCourseInteractiveGuideShortTitle: "Choose an alias for the course.",
  createCourseInteractiveGuideStartDate: "Choose the course start date.",
  createCourseInteractiveGuideSubmit: "Submit course",
  createCourseInteractiveGuideTitle: "Create Course",
  createCourseInteractiveGuideWelcome: "Welcome, let's create a course.",
  createIdentitiesInteractiveGuideCopy: "You can copy it clicking this button",
  createIdentitiesInteractiveGuideExample: "Here's an example of how you should upload the identities in the file",
  createIdentitiesInteractiveGuideFormat: "Remember to upload them in CSV format",
  createIdentitiesInteractiveGuideInformation: "Remember to read the important information.",
  createIdentitiesInteractiveGuideInformationConfirm: "After verifying that everything is correct, click on the 'Create Identities' button.",
  createIdentitiesInteractiveGuideInformationPassword: "After adding the file, review the records that were created and store the generated passwords in a secure place, as they will not be shown again.",
  createIdentitiesInteractiveGuidePassword: "Do you want to generate easy reading passwords?",
  createIdentitiesInteractiveGuideTitle: "Create Identities",
  createIdentitiesInteractiveGuideUpload: "Upload your identities. Remember that it must be a CSV format file.",
  createIdentitiesInteractiveGuideWelcome: "Hello, let's create identities!",
  createProblemInteractiveGuideCreationMethod: "Select the method to create the problem (using Problem Creator or uploading a zip file).",
  createProblemInteractiveGuideFile: "Upload the .zip file with the problem information.",
  createProblemInteractiveGuideOpenCreator: "Open the interactive Problem Creator to build your problem directly in the browser.",
  createProblemInteractiveGuideOrigin: "Choose the source of the problem.",
  createProblemInteractiveGuideProblemTitle: "Choose the problem title.",
  createProblemInteractiveGuideShortTitle: "Choose a short title for the problem.",
  createProblemInteractiveGuideTagsAndLevel: "Choose the tags and level for your problem",
  createProblemInteractiveGuideTitle: "Create a problem",
  createProblemInteractiveGuideType: "Choose the problem type.",
  createProblemInteractiveGuideValidator: "Select the output validator type.",
  createProblemInteractiveGuideWelcome: "Welcome, let's create a problem.",
  createTeamsGroup: "Create new teams group",
  createZipFileForProblem: "Use the Problem Creator tool",
  createZipFileForProblemDesc: "Build a problem zip step by step",
  cronControlPlaneDuration: "Duration",
  cronControlPlaneJobDisabled: "This job is disabled. Enable it before requesting a rerun.",
  cronControlPlaneJobsHeading: "Jobs",
  cronControlPlaneLastRun: "Last run",
  cronControlPlaneLastStatus: "Last status",
  cronControlPlaneName: "Name",
  cronControlPlaneNoPhases: "No phase detail",
  cronControlPlaneRows: "Rows",
  cronControlPlaneRunsHeading: "Recent runs",
  cronControlPlaneSchedule: "Schedule",
  cronControlPlaneScheduleDaily: "every day at %(time)",
  cronControlPlaneScheduleEveryMinutes: "every %(minutes) minutes",
  cronControlPlaneScheduleHourly: "every hour at minute %(minute)",
  cronControlPlaneScheduleMonthly: "day %(dayOfMonth) of every month at %(time)",
  cronControlPlaneScheduleWeekly: "every %(weekday) at %(time)",
  cronControlPlaneStarted: "Started",
  cronControlPlaneStatus: "Status",
  csrfException: "Cross-site Request Forgery attempt",
  currentStatus: "Current state",
  datePickerFormat: "mm/dd/yyyy",
  dateTimePickerFormat: "mm/dd/yyyy hh:ii",
  deleteProblemLevel: "Delete problem level",
  demotionProblemEmailBannedBody: "<p>Dear <strong>%(user_name)</strong>:</p><p>The access to your problem <strong>%(problem_name)</strong> in omegaUp has been restricted because it was reported as inappropriate. The omegaUp team has reviewed this report and confirmed that the problem is not appropriate because <em>%(reason)</em>.</p><p>To unblock the problem and have it appear again in the list of problems, please follow the steps below:</p><p><ol><li>Review and edit your problem: make sure you describe a problem, it is not offensive or spam.</li><li>Once you have resolved the reason on why your problem was blocked, send an email <a href=\"mailto:quality@omegaup.com\" target=\"_top\">quality@omegaup.com</a> to be reviewed and reactivated.</li></ol></p><p>If the steps mentioned above are not followed, the problem will not be shown again in the list of problems, nor can it be used in competitions. In case of a relapse in three occasions, omegaUp reserves the right to suspend your user account.</p><p>omegaUp is a platform to help users improve their software engineering skills by solving code problems and competing in programing contests. omegaUp welcomes all the problems that help meet that goal.</p><p>Thanks,</p><p>omegaUp team</p>",
  demotionProblemEmailBannedSubject: "Problem [%(problem_name)] has been reported as inappropriate",
  demotionProblemEmailWarningBody: "<p>Dear %(user_name):</p><p>A warning has been put on your problem %(problem_name) in omegaUp because it was reported by the users. The omegaUp team has reviewed this report and confirmed that the problem has room for improvement because %(reason).</p><p>To remove the warning notification on the problem please follow the steps below:</p><p><ol><li>Review and edit your problem.</li><li>Once you have resolved the reason on why a warning has been put on your problem, send an email to quality@omegaup.com to be reviewed.</li></lo></p><p>If the steps mentioned above are not followed, the problem will show a warning sign in the list of problems.</p><p>omegaUp is a platform to help users improve their software engineering skills by solving code problems and competing in programing contests. omegaUp welcomes all the problems that help meet that goal.</p><p>Thanks,</p><p>omegaUp team</p>",
  demotionProblemEmailWarningSubject: "A warning has been put on your problem %(problem_name)",
  demotionProblemMultipleAnswerNo: "No, just this report",
  demotionProblemMultipleAnswerYes: "Yes, check all",
  demotionProblemMultipleQuestion: "Do you want to do this for all reports of this problem?",
  demotionProblemNotificationBanned: "Problem [%(problem_name)] has been reported as inappropriate. For more details check your email.",
  demotionProblemNotificationWarning: "A warning has been put on your problem %(problem_name). For more details check your email.",
  dependentsBlockedMessage: "Account locked. To validate the dependent, it is necessary to contact our support team.",
  dependentsEmptyState: "You don\u2019t have any dependents yet.",
  dependentsMessage: "It is necessary to approve your dependent's account within %(days) days. Otherwise, the account will be deleted.",
  dependentsOneDayUntilVerificationDeadline: "Attention! You only have 1 day left to approve your dependent's account. Otherwise, the account will be deleted.",
  dependentsStatus: "Status",
  dependentsTitle: "Parental access",
  dependentsUser: "User",
  dependentsVerified: "Dependent's account has been verified successfully",
  detectLanguage: "Detect Language",
  downloadError: "Error while downloading the problem",
  downloadZip: "Download zip",
  duplicateTagsNotAllowed: "Duplicated tags are not allowed. There is at least one duplicated tag in the list: %(tags) <br> Please fix the information.",
  editFieldRequired: "Missing required field",
  elementNotFound: "No case or group matching the provided ID was found",
  emailNotVerified: "Your email is not verified yet. Please look for the verification email in your inbox and spam folder. If you still have problems, please contact soporte@omegaup.com for support.",
  enterContest: "Enter Contest",
  ephemeralGraderAlert: "You need a larger screen size to use the Ephemeral Grader. Try putting your phone in horizontal position or use another device.",
  ephemeralGraderDescription: "Allow users to use the EphemeralGrader IDE to test their code directly on the platform.",
  ephemeralGraderDisabled: "The EphemeralGrader IDE is currently disabled.",
  ephemeralGraderEnable: "Enable EphemeralGrader IDE",
  ephemeralGraderUpdated: "Ephemeral Grader settings updated",
  errorWhileSendingMail: "There was an error sending the verification email. Please try again later or contact soporte@omegaup.com for support. Your email is not verified yet.",
  feedbackLeftBy: "%(date), by:",
  feedbackNotSentYet: "The feedback for this submission has not been sent yet.",
  feedbackSuccessfullyAdded: "The feedback has been successfully added.",
  feedbackSuccessfullyUpdated: "The feedback has been successfully updated.",
  feedbackTitle: "Submission feedback",
  fileUploadError: "The uploaded file could not be processed",
  firstSumbissionWithIdentity: "Note that you are trying to send a submission with an identity account",
  fontSize: "Font-Size",
  forSelectedItems: "For selected items",
  forbiddenInVirtualContest: "Forbidden in virtual contest",
  formValidationSummaryTitle: "Please fix the following errors:",
  frontPageDevelopers: "Developers",
  frontPageFooter: "Code a better future. For everyone.",
  frontPageFooterAboutUs: "About omegaUp",
  frontPageFooterCodeConduct: "Code of Conduct",
  frontPageFooterContact: "Contact us",
  frontPageFooterCopyright: "Copyright \u00a9 %(currentYear) omegaUp, Inc. All rights reserved.",
  frontPageFooterHelpUs: "Help us",
  frontPageFooterLogoAlt: "omegaUp logo",
  frontPageFooterOrganization: "Organization",
  frontPageFooterPrivacyPolicy: "Privacy policy",
  frontPageFooterSite: "Site",
  frontPageFooterSponsors: "Sponsor",
  frontPageFooterTeam: "Team",
  frontPageNextContests: "Upcoming contests",
  generalError: "Oops. I've encountered an internal error. Please try again.",
  gitServerError: "An error occurred while communicating with the Git server.",
  graderDiffEditorModified: "Modified",
  graderDiffEditorOriginal: "Original",
  graderDiffEditorReadOnly: "Read-only",
  groupAdminAdded: "Group admin successfully added.",
  groupAdminRemoved: "Group admin successfully removed.",
  groupAlreadyExists: "A group with that name already exists",
  groupCreateIdentities: "Create identities",
  groupEditEdit: "Edit",
  groupEditGroupUpdated: "The group has been successfully updated.",
  groupEditMemberAdded: "Member successfully added!",
  groupEditMemberPasswordUpdated: "Identity's password successfully updated!",
  groupEditMemberRemoved: "Member successfully removed!",
  groupEditMemberUpdated: "Member successfully updated!",
  groupEditMembers: "Members",
  groupEditMembersAddMembers: "Add members",
  groupEditMembersChangePassword: "Click here to change password",
  groupEditMembersCoder: "Coder",
  groupEditMembersEdit: "Click here to edit member information",
  groupEditMembersRemove: "Click here to remove member from the group",
  groupEditMembersTitle: "Add members for the team: %(username)",
  groupEditScoreboards: "Scoreboards",
  groupEditScoreboardsAdd: "Create scoreboard",
  groupEditScoreboardsAddContest: "Add contest",
  groupEditScoreboardsAdded: "Scoreboard successfully added!",
  groupEditScoreboardsContestsAdded: "Contest successfully added!",
  groupEditScoreboardsContestsRemoved: "Contest successfully removed!",
  groupEditScoreboardsEdit: "Edit scoreboard %(scoreboard)",
  groupEditTitle: "Edit group",
  groupEditTitleWithName: "Edit group %(name)",
  groupIdentitiesNotRequiredPrivileges: "You do not have the required permissions to create identities. To obtain them, please send an email to *[soporte@omegaup.com](mailto:soporte@omegaup.com?subject=Request%20for%20Access%20to%20Identity%20Creation)* with the subject \"Request for Access to Identity Creation\" and include the following details:\n\n- Name of the contest\n- Organizing institution\n- Contact name at the organizing institution\n- Contact's omegaUp username\n- Approximate number of contestants \n- Date of the contest\n\n\nIf your contest is starting in less than 48 hours, include the word **\"URGENT\"** in the subject of your email.",
  groupMemberUsernameInUse: "There is at least one duplicated account name in the identities of the group: <br> %(usernames) <br> Please fix the information.",
  groupModalBack: "Back",
  groupModalSave: "Save",
  groupNewFormCreateGroup: "Create group",
  groupNewFormDescription: "Group description",
  groupNewFormOnlyAC: "Only count ACs",
  groupNewFormUpdateGroup: "Save group",
  groupNewFormWeight: "Score weight",
  groupNotFound: "Group not found",
  groupScoreboardDetailsCoder: "Coder",
  groupsCanNotBeAddedInContestForTeams: "Groups cannot be added in contests for teams",
  groupsCreateNew: "New group",
  groupsCsvHelp: "<p>Quickly add multiple identities to this group. Identities are not regular accounts, and don't need to have an email or validate their account.</p>\n<p>Identities should be in a <code>.csv</code> file with the following format:\n<samp><pre>username,name,country_id,state_id,gender,school_name\nusername-1,Developer Diana,MX,AGU,female,Best School\nusername-2,Danny Dev,MX,AGU,male,Best School</pre></samp></p>",
  groupsIdentitiesSuccessfullyCreated: "The identities have been created and linked to the group.",
  groupsIdentityWarning: "Save the passwords in a safe place, because once you create the identities there will be no way of recovering the passwords.",
  groupsInvalidCsv: "Please upload a valid CSV file.",
  groupsUploadCsvFile: "Upload CSV file",
  homepageCompeteSectionDescription: "Participate in programming contests and test your knowledge",
  homepageCompeteSectionTitle: "Compete",
  homepageCreateSectionDescription: "Organize your contest with problems that are available on the platform or create your own problems",
  homepageCreateSectionTitle: "Create",
  homepageGetStartedTitle: "Getting started with omegaUp",
  homepageHowItWorks: "How it works",
  homepageSponsorsSectionTitle: "Thanks to our Sponsor",
  homepageTeachSectionDescription: "Track your student's progress through assignments and tests that are automatically assessed",
  homepageTeachSectionTitle: "Teach",
  homepageTrainSectionDescription: "Solve problems and improve your skills",
  homepageTrainSectionTitle: "Train",
  identityAlreadyAssociated: "You already have one identity associated with the same group.",
  identityAlreadyInUse: "Identity is already used by another account.",
  identityInGroup: "Identity is already associated to the group.",
  incompatibleArgs: "Arguments can't be set simultaneously",
  interactiveGuideDoneButton: "Done",
  interactiveGuideNextButton: "Next",
  interactiveGuidePreviousButton: "Previous",
  invalidJson: "The provided JSON is invalid",
  invalidLanguage: "Invalid language",
  invalidParameters: "Invalid parameters.",
  invalidResetToken: "Invalid reset token.",
  invalidScoreboardUrl: "Invalid scoreboard url.",
  invalidStatementType: "Invalid statement type.",
  invalidUser: "Invalid account name.",
  invalidVisibility: "The visibility parameter can be one of the following values: deleted, private_banned, public_banned, private_warning, private, public_warning, public and promoted",
  joinCourseInteractiveGuideJoin: "Click the start button to join the course.",
  joinCourseInteractiveGuideSearch: "Here you can search for courses by name.",
  joinCourseInteractiveGuideTabs: "Here you can navigate between see the courses you are studying, explore new courses and see the courses you have completed.",
  joinCourseInteractiveGuideTitle: "Joining a Course",
  joinCourseInteractiveGuideWelcome: "Hello! Here you can find your courses.",
  keepLanguage: "Keep %(lang)",
  languageDetected: "%(lang) detected",
  lastUpdate: "Last update",
  latestSubmissionsTitle: "Latest submissions",
  levelTagHelp: "The levels must coincide with educational stages and go hand in hand with the courses that students usually take.",
  libinteractiveDownload: "Download",
  libinteractiveFilename: "File to submit",
  libinteractiveIdlFilename: ".idl filename",
  libinteractiveIdlFilenameHelp: "The name of the .idl file (without extension). Must be between 1 and 32 alphanumeric characters.",
  libinteractiveLanguage: "Language",
  libinteractiveOs: "Operating System",
  libinteractiveTitle: "Interactive templates",
  liveStatistics: "Live Statistics",
  locale: "en",
  lockdown: "Operation not allowed in lockdown mode",
  lockdownDetailsDisabled: "Viewing source code has been temporarily disabled.",
  lockdownMessageWarning: "Warning: in lockdown mode, your submissions will no longer be accessible if you leave the page.",
  loginAccountName: "Account name",
  loginDateOfBirth: "Date of birth",
  loginDisabled: "Your account has been inactive for a long time and has been disabled for your security. Please contact soporte@omegaup.com to login again.",
  loginEmail: "E-mail address",
  loginEmailUsername: "E-mail or user",
  loginFacebookEmptyEmailError: "An email address is needed to use omegaUp. Please grant access to Facebook's email to continue",
  loginFederated: "Login using these sites",
  loginFormInteractiveGuideFederated: "Use a third-party login if you prefer.",
  loginFormInteractiveGuideGithub: "Sign in with GitHub here.",
  loginFormInteractiveGuideGoogle: "Sign in with Google here.",
  loginFormInteractiveGuideNative: "Or sign in with your omegaUp account.",
  loginFormInteractiveGuidePassword: "Enter your password.",
  loginFormInteractiveGuideRecover: "Forgot your password? Recover it here.",
  loginFormInteractiveGuideSubmit: "Click here to log in.",
  loginFormInteractiveGuideTitle: "Login",
  loginFormInteractiveGuideUsername: "Enter your username or email.",
  loginFormInteractiveGuideWelcome: "Welcome back! Let's get you signed in.",
  loginGitHubError: "Failed to sign in with GitHub",
  loginGitHubInvalidCSRFToken: "Invalid GitHub CSRF token",
  loginGitHubNoEmail: "Your GitHub account doesn't have a verified email",
  loginGithub: "Sign in with GitHub",
  loginGoogleInvalidCSRFToken: "Invalid CSRF token",
  loginHeader: "Login to omegaUp",
  loginLogIn: "Log in",
  loginNative: "omegaUp account",
  loginParentEmail: "Parent e-mail address",
  loginPassword: "Password",
  loginPasswordCreate: "Password (Min. 8 characters)",
  loginPasswordTooShort: "Password is too short.",
  loginRecover: "Forgot your password?",
  loginRepeatPassword: "Repeat password",
  loginRequired: "You need to login to perform that action.",
  loginSignUp: "Register",
  loginSignupHeader: "Create an omegaUp account, it's quick and easy!",
  loginThroughThirdParty: "Your account was created through a third-party login (Google, Facebook, etc.). Please login using that mechanism again in order to set a password.",
  logoutConfirmationTitle: "Confirm Logout",
  mailFromUserLikelyRemoved: "This mail is already in use. Probably it was used but the account was removed. If you want to use this email please contact soporte@omegaup.com for support",
  mailInUse: "This mail is already in use. Try again.",
  maintenanceModeActive: "Maintenance mode is active",
  maintenanceModeInactive: "Maintenance mode is inactive",
  maintenanceModeMessage: "Message to display",
  maintenanceModeMessagePlaceholder: "Enter the message that users will see during maintenance...",
  maintenanceModeTemplateCustomOption: "Other",
  maintenanceModeTemplateSelectPlaceholder: "Choose one option",
  maintenanceModeTitle: "Maintenance Mode",
  maintenanceModeTypeError: "Error",
  maintenanceModeTypeInfo: "Announcement",
  maintenanceModeTypeWarning: "Warning",
  makePrivate: "Make private",
  makePublic: "Make public",
  makeRegistration: "Make open with registration",
  matrixEditTitle: "Matrix editor",
  matrixModalBack: "Back",
  matrixModalColumns: "Columns",
  matrixModalDistinct: "Distinct",
  matrixModalDistinctAll: "All",
  matrixModalDistinctColumn: "Column",
  matrixModalDistinctHeader: "Select distinct type",
  matrixModalDistinctNone: "None",
  matrixModalDistinctRow: "Row",
  matrixModalGenerate: "Generate",
  matrixModalGeneratedArray: "Generated matrix",
  matrixModalMaximum: "Maximum",
  matrixModalMinimum: "Minimum",
  matrixModalRows: "Rows",
  matrixModalSave: "Save",
  messageMakeYourContestsPublic: "You have private contests that have already ended. Please consider making them public to contribute to the community.",
  messageMakeYourProblemsPublic: "You have private problems that have already been used. Please consider making them public to contribute to the community.",
  methodNotAllowed: "This API endpoint does not allow GET requests. Use POST, PUT, or PATCH.",
  missingCase: "Case information was not found",
  missingCaseField: "A required field is missing in the case information",
  missingCaseFiles: "The original input or output files for the requested case were not found",
  missingCaseOrGroup: "Invalid structure: a case or a group was expected",
  missingGroup: "Group information was not found",
  missingGroupField: "A required field is missing in the group information",
  missingOrEmptyId: "No valid ID was found in the request",
  modalConsentCookiesAccept: "Accept all cookies",
  modalConsentCookiesDecline: "Accept only essential cookies",
  modalConsentCookiesDescription: "We use cookies to ensure you get the best experience on our website.",
  monacoEditorClipboardError: "Failed to copy code to clipboard",
  monacoEditorCodeEditorContent: "Code editor content",
  monacoEditorCopied: "Copied!",
  monacoEditorCopyCode: "Copy code",
  monacoEditorEnterFullscreen: "Enter fullscreen",
  monacoEditorExitFullscreen: "Exit fullscreen (Esc)",
  monacoEditorExitFullscreenLabel: "Exit fullscreen",
  monacoEditorFontSizeAriaLabel: "Font size",
  monacoEditorFontSizeOption: "%(size)px",
  monacoEditorFullscreen: "Fullscreen (F11)",
  monacoEditorRegionLabel: "Code editor for %(filename)",
  monacoEditorReset: "Reset",
  monacoEditorResetAriaLabel: "Reset to default code",
  monacoEditorResetModalMessage: "Are you sure you want to reset the code to its default state? All changes will be lost.",
  monacoEditorResetModalTitle: "Reset Code",
  monacoEditorResetTitle: "Reset to default code (Ctrl+Shift+R)",
  monacoEditorToolbarAriaLabel: "Editor controls",
  monacoEditorUntitled: "untitled",
  mustLoginToJoinContest: "You must login to join this contest",
  mustRegisterToJoinContest: "You must register to join this contest.",
  mustRegisterToJoinCourse: "You must register to join this course.",
  myproblemsListCreateProblemWithExistingZipFile: "I have a zip file",
  myproblemsListMyProblems: "My Problems",
  navAlgorithmsBook: "Tutorial Book \"Problemas y Algoritmos\"",
  navAlgorithmsBookDesc: "By Luis Vargas",
  navAllCourses: "All courses",
  navAllProblems: "All problems",
  navAuthorRanking: "Contributors ranking",
  navAuthorRankingDesc: "Top problem authors",
  navBlog: "Blog",
  navBlogDesc: "Platform updates and articles",
  navCoderOfTheMonth: "Coder of the month overall",
  navCoderOfTheMonthDesc: "Monthly featured coder",
  navCoderOfTheMonthFemale: "Coder of the month for her",
  navCoderOfTheMonthFemaleDesc: "Monthly featured female coder",
  navCompareUsers: "Compare Users",
  navCompareUsersDesc: "Compare two users side by side",
  navCompetitiveProgrammingDataStructuresBook: "Competitive Programming Data Structures",
  navCompetitiveProgrammingDataStructuresBookDesc: "By Hugo Humberto Morales Pe\u00f1a",
  navContests: "Contests",
  navContestsEnrolled: "Contests enrolled",
  navCourses: "Courses",
  navCoursesEnrolled: "Courses enrolled",
  navCreateProblemFromScratch: "Create Problem from Scratch",
  navCreateProblemFromScratchDesc: "Build a new problem step by step",
  navCreateProblemFromZip: "Create Problem from ZIP",
  navCreateProblemFromZipDesc: "Upload a problem zip file you already have",
  navDependents: "My dependents",
  navDiscord: "Discord Server",
  navDiscordDesc: "Chat with the community",
  navHelp: "Help",
  navKarel: "Karel.js",
  navKarelDesc: "Introductory programming environment",
  navMyContent: "My content",
  navMyContests: "My contests",
  navMyCourses: "My courses",
  navMyGroups: "My groups",
  navMyProblems: "My problems",
  navMyQualityNomination: "My problem reports",
  navMyTeamsGroups: "My teams groups",
  navOmegaUpIDE: "omegaUp IDE",
  navOmegaUpIDEDesc: "Run and test code online",
  navProblemStatementEditor: "Problem Statement Editor",
  navProblemStatementEditorDesc: "Create and format problem statements",
  navProblems: "Problems",
  navProfileProblems: "Solved and unsolved problems",
  navQualityNominationQueue: "Reports",
  navQualityNominationQueueDesc: "Review community nominations",
  navRanking: "Ranking",
  navSchoolOfTheMonth: "School of the month",
  navSchoolOfTheMonthDesc: "Monthly featured school",
  navSchoolRanking: "School ranking",
  navSchoolRankingDesc: "Top schools by activity",
  navTutorials: "Tutorials",
  navTutorialsDesc: "Video guides for getting started",
  navUserAvatarAlt: "User avatar",
  navUserRanking: "User ranking",
  navUserRankingDesc: "Top users by score",
  navViewBadges: "View badges",
  navViewContests: "View Contests",
  navViewContestsDesc: "Compete in live and past contests",
  navViewCourses: "View Courses",
  navViewCoursesDesc: "Learn with guided problem sets",
  navViewLatestSubmissions: "View Latest Submissions",
  navViewLatestSubmissionsDesc: "Recent runs across the site",
  navViewProblems: "Browse Problems",
  navViewProblemsAll: "Problems List",
  navViewProblemsAllDesc: "The full problem catalog",
  navViewProblemsDesc: "Browse problems by topic",
  navViewProfile: "My profile",
  navbarGoToHomepage: "Go to homepage",
  navbarLogin: "Log in",
  navbarRegister: "Sign up",
  navbarScrollToTop: "Scroll to top",
  newPublicTagsNotAllowed: "It is not allowed to add new public tags",
  noChangesDetected: "No changes were detected",
  noCoders: "No coders.",
  nominationsRangeHeader: "Problem reports (from %(lowCount) to %(highCount))",
  notProblemLevelTag: "The tag sent is not a level tag.",
  notificationContestClarificationRequest: "A new clarification has been requested for problem %(problemAlias) of the contest %(contestAlias), that you manage.",
  notificationContestClarificationResponse: "Your clarification request for problem %(problemAlias) of the contest %(contestAlias), has been answered.",
  notificationContestRegisterRequest: "%(username) has requested to register for the contest %(contestTitle) that you manage.",
  notificationContestRegisterationAccepted: "Your registration request for contest %(contestTitle) has been **accepted**.",
  notificationContestRegisterationRejected: "Your registration request for contest %(contestTitle) has been **rejected**.",
  notificationCourseAddAdmin: "You have been invited to be an administrator for course %(courseName).",
  notificationCourseAddTeachingAssistant: "You have been invited to be a teaching assistant for course %(courseName).",
  notificationCourseAssignmentAdded: "New content has been added to course %(courseName).",
  notificationCourseAssignmentProblemAdded: "A new problem has been added to an assignment for course %(courseName).",
  notificationCourseClarificationRequest: "A new clarification has been requested for problem %(problemAlias) of the course %(courseName), that you manage.",
  notificationCourseClarificationResponse: "Your clarification request for problem %(problemAlias) of the course %(courseName), has been answered.",
  notificationCourseRegistrationAccepted: "Your registration request for course %(courseName) has been **accepted**.",
  notificationCourseRegistrationManual: "You have been invited to join the course %(courseName).",
  notificationCourseRegistrationRejected: "Your registration request for course %(courseName) has been **rejected**.",
  notificationCourseRegistrationRequest: "**%(username)** has requested access to course %(courseName).",
  notificationCourseRequestFeedback: "**%(username)** has requested feedback to the assignment ***%(assignmentName)*** in the course ***%(courseName)***",
  notificationCourseSubmissionFeedback: "The feedback about your submission for problem ***%(problemAlias)*** of the course ***%(courseName)*** has been submitted",
  notificationCourseSubmissionFeedbackThread: "**%(username)** has responded to feedback on the submission for the problem ***%(problemAlias)*** in the course ***%(courseName)***",
  notificationNewBadge: "You have received a new badge: **%(badgeName)**.",
  notificationNewContestCertificate: "Congratulations! You have received a certificate for your recent achievement in the \"%(contest_title)\" contest. Click to download it.",
  notificationNotFound: "Notification not found",
  notificationsMarkAllAsRead: "Mark all as read",
  notificationsNoNewNotifications: "No new notifications.",
  officialSolutionsInfo: "How do solutions to problems work?",
  omegaUpTitleMyDependents: "My dependents",
  omegaupOperationsDashboardDescription: "Centralized administrative tools",
  omegaupOperationsDashboardToggleSidebar: "Show or hide the sidebar menu",
  omegaupTitleAdminCrons: "Cron jobs",
  omegaupTitleAdminGlobalSettings: "Admin settings",
  omegaupTitleAdminOperations: "Operations Dashboard",
  omegaupTitleAdminUsers: "Coders administration",
  omegaupTitleAuthorsRank: "Authors rank",
  omegaupTitleBadges: "Badges",
  omegaupTitleCarouselManagement: "Carousel Management",
  omegaupTitleCertificate: "Certificates",
  omegaupTitleCertificateValidation: "Verify certificate",
  omegaupTitleCodersofthemonth: "Coders of the month",
  omegaupTitleCodersofthemonthFemale: "Coders of the month female",
  omegaupTitleCollections: "Collections",
  omegaupTitleCollectionsByAuthor: "Problems by author",
  omegaupTitleCollectionsByLevel: "Problems by level",
  omegaupTitleCommonIndex: "Welcome",
  omegaupTitleCompareUsers: "Compare Users",
  omegaupTitleContest: "Contest",
  omegaupTitleContestAddAdmin: "Admins",
  omegaupTitleContestEdit: "ContestEdit",
  omegaupTitleContestList: "Contests list",
  omegaupTitleContestNew: "ContestNew",
  omegaupTitleContestPractice: "Contest (Practice mode)",
  omegaupTitleContestPrint: "Contest (Print mode) - %(contestTitle)",
  omegaupTitleContestReport: "Report for contest: %(contestName)",
  omegaupTitleContestScoreboard: "Contest scoreboard",
  omegaupTitleContestStats: "Contest stats",
  omegaupTitleCourseClarifications: "Course clarifications",
  omegaupTitleCourseDetails: "Course details",
  omegaupTitleCourseEdit: "Edit course",
  omegaupTitleCourseIntro: "Enter course",
  omegaupTitleCourseNew: "New course",
  omegaupTitleCourseScoreboard: "Course scoreboard",
  omegaupTitleCourseStatistics: "Course statistics",
  omegaupTitleCourses: "Courses",
  omegaupTitleDocs: "Documentation index",
  omegaupTitleGroupScoreboardDetails: "Group scoreboard details",
  omegaupTitleGroups: "Groups",
  omegaupTitleGroupsEdit: "Edit group",
  omegaupTitleGroupsNew: "New group",
  omegaupTitleGroupsScoreboardEdit: "Edit scoreboard",
  omegaupTitleLatestSubmissions: "Latest submissions",
  omegaupTitleLibInteractive: "libinteractive",
  omegaupTitleLogin: "Login",
  omegaupTitleLogout: "Logout",
  omegaupTitleMyCertificates: "My certificates",
  omegaupTitleMyContests: "My contests",
  omegaupTitleMyProblemsList: "MyProblemsList",
  omegaupTitleParentalVerificationToken: "Parental verification token",
  omegaupTitlePrivacyPolicy: "Privacy Policy",
  omegaupTitleProblem: "Problem",
  omegaupTitleProblemCreator: "Problem Creator",
  omegaupTitleProblemEdit: "Problem settings",
  omegaupTitleProblemNew: "New problem",
  omegaupTitleProblemPrint: "Problem (Print mode) - %(problemTitle)",
  omegaupTitleProblemStats: "Problem stats",
  omegaupTitleProblems: "Problems",
  omegaupTitleProfile: "Profile",
  omegaupTitleQualityNominationDetails: "Reported problem details",
  omegaupTitleQualityNominationList: "Problem report list",
  omegaupTitleQualityNominationMyList: "My problem report list",
  omegaupTitleRecoverPassword: "Recover your password",
  omegaupTitleSchoolOfTheMonth: "Schools of the Month",
  omegaupTitleSchoolProfile: "School Profile",
  omegaupTitleSchoolsRank: "School ranking",
  omegaupTitleScoreboardmerge: "Scoreboard merge",
  omegaupTitleStatementEditor: "Statement editor",
  omegaupTitleStudentsProgress: "Students' progress",
  omegaupTitleSupportDashboard: "Support dashboard",
  omegaupTitleTeamsGroupEdit: "Edit teams group",
  omegaupTitleTeamsGroupNew: "New teams group",
  omegaupTitleTeamsGroups: "Teams groups",
  omegaupTitleUpdatePrivileges: "Update privileges",
  omegaupTitleUsersEditEmail: "Edit email",
  omegaupTitleUsersRank: "User ranking",
  onlyDemotionsSupported: "Resolution only supported for demotions for now.",
  openInKarelJs: "You can use karel.js to solve this problem.",
  openInReKarel: "You can use ReKarel 2.0.0 to solve this problem.",
  openProblemCreator: "Open problem creator",
  originalContestHasNotEnded: "The original contest has not yet ended",
  outputOnly: "Output only",
  outputOnlyDownloadInput: "Download .zip with inputs",
  outputOnlyFiles: "Output only files",
  over13yearsOld: "I am over 13 years old.",
  parameterDateTooLarge: "Parameter is larger than the maximum date of %(upper_bound!timestamp)",
  parameterDateTooSmall: "Parameter is smaller than the minimum date of %(lower_bound!timestamp)",
  parameterEmpty: "Empty parameter.",
  parameterInvalid: "Invalid parameter.",
  parameterInvalidAlias: "Parameter can only contain letters, digits, and _. Spaces are not allowed",
  parameterInvalidCaseExtension: "The case file extension is invalid",
  parameterInvalidCaseName: "The case name is invalid",
  parameterInvalidFile: "The file could not be read or is invalid",
  parameterInvalidGroupAlias: "Invalid parameter: group. That group does not exist, create it at https://omegaup.com/group/new/",
  parameterInvalidStateDoesNotBelongToCountry: "The selected state does not belong to the country based on ISO 3166-2.",
  parameterInvalidStateNeedsToBelongToCountry: "You need to select a country in order to select a state.",
  parameterInvalidValidZipUpload: "The ZIP file was not uploaded correctly or is invalid",
  parameterInvalidZipFilePath: "The ZIP file contains an invalid path (forbidden characters detected)",
  parameterInvalidZipFileSizeTooLong: "The file exceeds the maximum allowed size of %(max_length) MB",
  parameterInvalidZipIntegrity: "The ZIP file is corrupted or could not be opened",
  parameterName_finish_time: "Finish time",
  parameterNotADate: "Parameter must be a date.",
  parameterNotANumber: "Parameter must be a number.",
  parameterNotFound: "Parameter value not found.",
  parameterNotInExpectedSet: "Value (%(bad_elements)) not in expected set (%(expected_set)).",
  parameterNumberTooLarge: "Parameter is larger than the maximum value of %(upper_bound).",
  parameterNumberTooSmall: "Parameter is smaller than the minimum value of %(lower_bound).",
  parameterStringTooLong: "Parameter is longer than %(max_length) characters.",
  parameterStringTooShort: "Parameter is shorter than %(min_length) characters.",
  parameterUsernameInUse: "Account name is not available",
  parentEmailBody: "Enter this token to link your child's account %(omegaup_url)/user/parentalverification/token/%(parental_verification_token)/",
  parentEmailSubject: "Generated Token",
  parentalTokenNotFound: "Parental token not found",
  parentalTokenVerified: "The parental token has been verified successfully.",
  passwordAddRequestSuccess: "Your password has been added.",
  passwordCopyToken: "Copy token",
  passwordGenerateToken: "Generate token",
  passwordGenerateTokenDesc: "Click on \"Generate token\" to create link",
  passwordHidePassword: "Hide password",
  passwordHumanReadable: "Include human-readable passwords",
  passwordMismatch: "Password mismatch.",
  passwordResetLinkCopiedToClipboard: "Link was copied to the clipboard",
  passwordResetMinWait: "You should wait a few minutes before another request.",
  passwordResetPassword: "New password",
  passwordResetPasswordConfirmation: "New password confirmation",
  passwordResetRequestSuccess: "Instructions have been sent to your email.",
  passwordResetRequestTitle: "I forgot my password",
  passwordResetResetExpired: "The time to reset your password has expired.",
  passwordResetResetSuccess: "Your password has been updated.",
  passwordResetResetTitle: "Reset password",
  passwordResetTokenWasGeneratedSuccessfully: "Token was generated successfully",
  passwordShowPassword: "Show password",
  pendingRegistrations: "Pending requests",
  pendingRegistrationsShowAll: "Show all requests",
  privacyPolicyNotAccepted: "Please read and accept the site's Use and Privacy Policy, as well as the Code of Conduct.",
  privacyStatementNotFound: "Privacy Statement not found.",
  privateTagsPlaceholder: "Ex. university, 2019, class-2020",
  problemAliasExists: "Problem alias already exists. Please try a different one.",
  problemBannedBecause: "This problem has been banned because:",
  problemBookmarkAdd: "Add bookmark",
  problemBookmarkAdded: "Bookmark added successfully",
  problemBookmarkRemove: "Remove bookmark",
  problemBookmarkRemoved: "Bookmark removed successfully",
  problemCollectionAuthors: "Authors",
  problemCollectionBackCollections: "\u25c4 Back to collections",
  problemCollectionEducationLevel: "By educational level",
  problemCollectionOthers: "Other collections",
  problemCollectionProblemCount: "%(count) problems",
  problemCollectionRandomKarelProblem: "Random Karel Problem",
  problemCollectionRandomLanguageProblem: "Random Problem",
  problemCollectionSearchProblem: "Problem Finder",
  problemCraetorGroupDownloadIn: "Save .in",
  problemCraetorGroupDownloadTxt: "Save .txt",
  problemCreatorAdd: "Add",
  problemCreatorAddLine: "Add line",
  problemCreatorAutomaticPoints: "Automatically calculate points",
  problemCreatorAutomaticPointsHelperCase: "The program will calculate the points of this case with the next formula: (group points - (sum of cases inside the group that have explicitly defined points)) / (number of cases inside the group that do not have explicitly defined points)",
  problemCreatorAutomaticPointsHelperGroup: "The program will calculate the points of this group with the next formula: (100 - (sum of groups that have explicitly defined points)) / (number of groups that do not have explicitly defined points)",
  problemCreatorAutomaticPointsRecommended: "Automatically calculate points (recommended)",
  problemCreatorCannotHaveSameName: "You cannot have two cases/groups with the same name",
  problemCreatorCase: "Case",
  problemCreatorCaseDownloadIn: "Download .in",
  problemCreatorCaseDownloadTxt: "Download .txt",
  problemCreatorCaseGroupNameHelper: "Lowercase and without whitespaces",
  problemCreatorCaseName: "Case Name",
  problemCreatorCasesTabIntroAddPanelIntro: "This panel lets you add a new test case.",
  problemCreatorCasesTabIntroAddPanelTitle: "Add Case Panel",
  problemCreatorCasesTabIntroSidebarIntro: "Use this sidebar to manage your test cases.",
  problemCreatorCasesTabIntroSidebarTitle: "Test Cases Sidebar",
  problemCreatorCode: "Code",
  problemCreatorCodeChooseFile: "Choose File",
  problemCreatorCodeNoFileChosen: "No file chosen",
  problemCreatorCodeSave: "Save",
  problemCreatorCodeTabIntroSaveCodeIntro: "Once you are done, click here to save your changes.",
  problemCreatorCodeTabIntroSaveCodeTitle: "Save Code",
  problemCreatorCodeTabIntroSelectLanguageIntro: "Choose the programming language for your code here.",
  problemCreatorCodeTabIntroSelectLanguageTitle: "Select a Language",
  problemCreatorCodeTabIntroUploadFileIntro: "You can upload a file with your code instead of typing it.",
  problemCreatorCodeTabIntroUploadFileTitle: "Upload File",
  problemCreatorCodeTabIntroWriteCodeIntro: "Use the code editor to write or modify your solution.",
  problemCreatorCodeTabIntroWriteCodeTitle: "Write Code",
  problemCreatorCodeUpload: "Or upload the file",
  problemCreatorCodeUploadFilesize: "The file size limit for uploaded files is %(limit)",
  problemCreatorContentPlaceHolder: "Content",
  problemCreatorCreateNewProblem: "Create new problem",
  problemCreatorCreateNewProblemBack: "Back",
  problemCreatorCreateNewProblemContinue: "Continue",
  problemCreatorCreateNewProblemWarning: "Do you want to start again? All the previous data will be lost and the creator will be reset. Save the current progress before creating a new one. To do so, click on the button \"Generate problem\".",
  problemCreatorDeleteCase: "Delete case",
  problemCreatorDeleteCases: "Delete cases",
  problemCreatorDeleteGroup: "Delete group",
  problemCreatorEditCase: "Edit case",
  problemCreatorEmpty: "",
  problemCreatorEraseOutput: "Clear output",
  problemCreatorGenerateProblem: "Generate Problem",
  problemCreatorGeneratingZip: "The problem file is still being generated. Please try again in a few seconds.",
  problemCreatorGroup: "Group",
  problemCreatorGroupName: "Group Name",
  problemCreatorGroups: "Groups",
  problemCreatorIntroCreateIntro: "Use this button to start from scratch and create a new problem.",
  problemCreatorIntroCreateTitle: "Create New Problem",
  problemCreatorIntroDownloadIntro: "Click this to download your problem as a .zip file once it's ready.",
  problemCreatorIntroDownloadTitle: "Download Problem",
  problemCreatorIntroLoadIntro: "Click here to upload a .zip file and load an existing problem.",
  problemCreatorIntroLoadTitle: "Load Problem",
  problemCreatorIntroNameIntro: "Here you can enter or edit the name of your problem.",
  problemCreatorIntroNameTitle: "Problem Name",
  problemCreatorIntroReadyIntro: "That's it! You're now ready to start creating problems.",
  problemCreatorIntroReadyTitle: "Ready to Create!",
  problemCreatorIntroWelcomeIntro: "Welcome to the Problem Creator! This guide will walk you through the key features of the interface.",
  problemCreatorIntroWelcomeTitle: "Welcome",
  problemCreatorIntroWorkspaceIntro: "This section is your workspace for building a problem. It includes tabs for writing the statement, adding solution code, test cases, and an official solution.",
  problemCreatorIntroWorkspaceTitle: "Workspace",
  problemCreatorLabelPlaceHolder: "Label",
  problemCreatorLayoutAddFromCase: "Add Layout from selected case",
  problemCreatorLayoutAddLineInfo: "Add line info",
  problemCreatorLayoutAddNew: "Add new Layout",
  problemCreatorLayoutBarClose: "Close Layout Bar",
  problemCreatorLayoutCopy: "Make a copy",
  problemCreatorLayoutDelete: "Delete layout",
  problemCreatorLayoutLoadToAll: "Load to all the cases",
  problemCreatorLayoutLoadToSelected: "Load to the selected case",
  problemCreatorLayoutNew: "New Layout",
  problemCreatorLayoutWordCopy: " copy",
  problemCreatorLayoutWordLayouts: "Layouts",
  problemCreatorLineArray: "Array",
  problemCreatorLineDelete: "Delete",
  problemCreatorLineEdit: "Edit",
  problemCreatorLineLine: "Single Line",
  problemCreatorLineMatrix: "Matrix",
  problemCreatorLineMultiline: "Multilines",
  problemCreatorLinesDelete: "Delete lines",
  problemCreatorLinesReorder: "Reorder",
  problemCreatorLoadProblem: "Load Problem",
  problemCreatorMarkdownImageTooLarge: "The image is too large. The maximum allowed size is %(limit). Please use a smaller image.",
  problemCreatorMarkdownPreviewInitialRender: "# Preview\n",
  problemCreatorMarkdownSave: "Save",
  problemCreatorMultipleCases: "Multiple cases",
  problemCreatorName: "Name",
  problemCreatorNewProblem: "New Problem",
  problemCreatorNoGroup: "No group",
  problemCreatorNumberOfCases: "Number of Cases",
  problemCreatorNumberOfCasesHelper: "The cases will have the name:",
  problemCreatorOnlyNumbers: "Only numbers",
  problemCreatorOpenBeforeSubmit: "Please open the problem creator and build your problem before submitting.",
  problemCreatorOutputPlaceHolder: "Output",
  problemCreatorPoints: "Points",
  problemCreatorPointsAbbreviation: "pts",
  problemCreatorPrefix: "Prefix",
  problemCreatorRenameLayout: "Rename Layout",
  problemCreatorRenameModalBack: "Back",
  problemCreatorRenameModalRename: "Rename",
  problemCreatorRenameModalTitle: "Rename Layout",
  problemCreatorSelectLanguage: "Select a language",
  problemCreatorSolution: "Solution",
  problemCreatorSolutionTabIntroEditorIntro: "Write your solution here using Markdown syntax.",
  problemCreatorSolutionTabIntroEditorTitle: "Markdown Editor",
  problemCreatorSolutionTabIntroPreviewIntro: "This section shows a live preview of your solution.",
  problemCreatorSolutionTabIntroPreviewTitle: "Live Preview",
  problemCreatorSolutionTabIntroSaveIntro: "Click this button to save your solution content.",
  problemCreatorSolutionTabIntroSaveTitle: "Save Solution",
  problemCreatorSolutionTabIntroToolbarIntro: "Use these buttons to format your solution in Markdown.",
  problemCreatorSolutionTabIntroToolbarTitle: "Markdown Toolbar",
  problemCreatorStatement: "Statement",
  problemCreatorSuffix: "Suffix",
  problemCreatorTestCases: "Test cases",
  problemCreatorTitle: "Problem creator",
  problemCreatorUngrouped: "Ungrouped",
  problemCreatorUngroupedCases: "Ungrouped cases",
  problemCreatorUpdateAlert: "The problem has been updated successfully.",
  problemCreatorUploadZip: "Upload",
  problemCreatorUploadZipMessage: "Upload the zip file of your problem here.",
  problemCreatorValidatePoints: "Validate and fix points",
  problemCreatorValidatePointsBack: "Back",
  problemCreatorValidatePointsButton: "Validate points",
  problemCreatorValidatePointsContinue: "Continue",
  problemCreatorValidatePointsWarning: "The points of a group should be equal to the sum of the points of the cases in it. Please continue to validate and fix the points distribution across all the groups.",
  problemCreatorZipFileIsNotComplete: "The zip file must contain cdp.data file",
  problemCreatorZipFileIsNotValid: "The uploaded file is not a valid zip file",
  problemCreatorZipFileUpload: "Upload zip file",
  problemDeployerChangeMissingSettingsJson: "The problem is missing a 'settings.json' file.",
  problemDeployerConfigBadLayout: "The commit to 'refs/meta/config' has the wrong layout.",
  problemDeployerConfigInvalidPublishingMode: "The chosen publishing mode is not supported.",
  problemDeployerConfigRepositoryNotAbsoluteUrl: "The repository to be published to is not an absolute URL.",
  problemDeployerConfigSubdirectoryMissingTarget: "The repository to be published to is missing a subdirectory target.",
  problemDeployerEsNoStatement: "No spanish statement found.",
  problemDeployerExceededZipSizeLimit: "Extracted zip size (%(size) MiB) is over max allowed (%(max_size) MiB). Rejecting.",
  problemDeployerFailed: "Unable to deploy problem.",
  problemDeployerInteractiveBadLayout: "The interactive problem's layout is not valid.",
  problemDeployerInternalError: "There was an internal problem in handling the problem update.",
  problemDeployerInternalGitError: "There was an internal git problem in handling the problem update.",
  problemDeployerInvalidZipFilename: "The path to the .zip file is invalid.",
  problemDeployerJsonParseError: "Could not parse the JSON file.",
  problemDeployerLibinteractiveValidationError: "Interactive problem is invalid.",
  problemDeployerMismatchedInputFile: "There was at least one .in file with a missing corresponding .out file.",
  problemDeployerNoStatements: "No statements found.",
  problemDeployerNotAReview: "A merge to the 'master' branch was attempted on a commit that is not a review.",
  problemDeployerOmegaupUpdateProblemOldVersion: "The problem is being migrated to a new version. Please try again later.",
  problemDeployerProblemBadLayout: "The problem's layout is not valid.",
  problemDeployerPublishedMustPointToCommitInMaster: "An update to the 'published' branch should point to a commit in the 'master' branch.",
  problemDeployerReviewBadLayout: "The provided review payload is malformed.",
  problemDeployerSlowRejected: "Problem would run for more than 5 minutes in case of TLE. Rejected.",
  problemDeployerTestsBadLayout: "The tests/ directory's layout is not valid.",
  problemDeployerTooManyObjectsInPackfile: "There were too many objects in the packfile.",
  problemDeprecated: "Problem is deprecated.",
  problemDetailsSource: "Source: %(source)",
  problemDownloadZip: "Download the zip file for the problem",
  problemEditAccess: "Access (optional)",
  problemEditAddAdmin: "Admins",
  problemEditAddTags: "Tags",
  problemEditBasicInfo: "Basic information",
  problemEditChooseVersion: "View version history",
  problemEditCommitMessage: "Update description",
  problemEditConfirmDeletion: "Confirm deletion",
  problemEditDeleteCancel: "Cancel",
  problemEditDeleteConfirmationMessage: "Are you sure you want to delete the problem?",
  problemEditDeleteOk: "Delete",
  problemEditDeleteRequireConfirmation: "Delete problem %(problemAlias)",
  problemEditDeleteSelectedProblemsConfirmationMessage: "Are you sure you want to delete the selected problems?",
  problemEditDeleteSelectedProblemsRequireConfirmation: "Delete selected problems",
  problemEditDeletingPrefix: "Deleting",
  problemEditEditMarkdown: "Edit statement",
  problemEditEditProblem: "Problem settings",
  problemEditEmailClarifications: "Receive questions about the problem by email",
  problemEditEvaluation: "Evaluation (optional)",
  problemEditFormAllowUserAddTags: "Allow showing coder-suggested tags for this problem",
  problemEditFormAppearsAsPublic: "Allow public access to the problem",
  problemEditFormCreateProblem: "Create problem",
  problemEditFormCustom: "Custom validator (validator.$lang$)",
  problemEditFormFile: "Attach zip file",
  problemEditFormFirstTimeCreatingAProblem: "First time creating a problem?",
  problemEditFormHereIsHowToWriteProblems: "Here is how to write the file",
  problemEditFormInputLimit: "Input size limit (bytes)",
  problemEditFormLanguages: "Problem type",
  problemEditFormLiteral: "Interpret stdout as score",
  problemEditFormMemoryLimit: "Memory limit (KiB)",
  problemEditFormNumericTokensWithTolerance: "Numeric tokens with tolerance of 1e-9",
  problemEditFormOutputLimit: "Output size limit (bytes)",
  problemEditFormTimeLimit: "Time limit per case (ms)",
  problemEditFormTokenByToken: "Token by Token",
  problemEditFormTokenCaseless: "Token by Token, ignoring upper/lowercase",
  problemEditFormUpdateMarkdown: "Update statement",
  problemEditFormUpdateProblem: "Update problem",
  problemEditFormUpdateSolution: "Update solution",
  problemEditFormValidatorTimeLimit: "Validator time limit (ms)",
  problemEditFormValidatorType: "Output validator type",
  problemEditFormWallTimeLimit: "Total time limit (ms) (max 60000 ms)",
  problemEditGoToProblem: "Go to problem",
  problemEditGroupScorePolicy: "Group scores",
  problemEditGroupScorePolicyMin: "Min",
  problemEditGroupScorePolicySumIfNotZero: "Sum (if all cases are not zero)",
  problemEditInputFile: "Input file (.in)",
  problemEditLimits: "Limits (optional)",
  problemEditOutputFile: "Output file (.out)",
  problemEditSaveCase: "Save case",
  problemEditSolution: "Edit Solution",
  problemEditSource: "Problem source",
  problemEditTagPublicRequired: "It's required to select at least one public tag and a problem level",
  problemEditTags: "Tags",
  problemEditUpdatedSuccessfully: "Problem updated successfully!",
  problemEditUpdatingCase: "Updating case",
  problemEditUpdatingGroup: "Updating group",
  problemEditValidation: "Validation",
  problemHasBeenUsedInContestOrCourse: "Problem can not be deleted, because it has been used in a contest or a course",
  problemHealthCheckDeprecatedPublic: "Deprecated but still public",
  problemHealthCheckJudgeErrors: "Judge errors",
  problemHealthCheckNeverSolved: "Never solved",
  problemHealthCheckNoLanguages: "No language enabled",
  problemHealthCheckType: "Check",
  problemHealthDetail: "Detail",
  problemHealthHeading: "Problems needing attention",
  problemHealthNoFindings: "No problems need attention right now",
  problemHealthProblem: "Problem",
  problemHealthSeverity: "Severity",
  problemHealthSeverityError: "Error",
  problemHealthSeverityWarning: "Warning",
  problemHealthSince: "Detected",
  problemIsBanned: "This problem has been banned.",
  problemIsNotPublic: "The problem is not public and is currently in at least one ongoing contest.",
  problemIsPrivate: "Problem is marked as private.",
  problemLevelAdvancedCompetitiveProgramming: "Advanced level: Competitive programming",
  problemLevelAdvancedSpecializedTopics: "Advanced level: Specialized topics",
  problemLevelBasicIntroductionToProgramming: "Basic level: Introduction to programming",
  problemLevelBasicKarel: "Basic level: Karel",
  problemLevelIntermediateAnalysisAndDesignOfAlgorithms: "Intermediate level: Analysis and design of algorithms",
  problemLevelIntermediateDataStructuresAndAlgorithms: "Intermediate level: Data Structures and algorithms",
  problemLevelIntermediateMathsInProgramming: "Intermediate level: Mathematics in programming",
  problemLevelUpdated: "Problem level added.",
  problemListShowAdminProblems: "Also show problems I manage",
  problemListShowAdminProblemsAndDeleted: "Also show problems I manage and deleted problems",
  problemNew: "Create problem",
  problemNotFound: "Problem not found.",
  problemNotFoundInContest: "Problem not found in contest.",
  problemNotFoundInProblemset: "Problem not found in problemset.",
  problemNotPartOfAssignment: "The problem is not part of the content.",
  problemPrintableVersion: "Get the printable version of the problem",
  problemRestrictedTagInteractive: "Interactive",
  problemRestrictedTagKarel: "Karel",
  problemRestrictedTagLanguage: "Language",
  problemRestrictedTagNoSubmissions: "Lecture (No submissions)",
  problemRestrictedTagOnlyOutput: "Only output",
  problemSettingsSummaryTitleWithLetter: "%(letter). %(problem_title)",
  problemSettingsSummaryTitleWithProblemId: "%(problem_id). %(problem_title)",
  problemSettingsSummaryTitleWithProblemsetTitleAndLetter: "%(problemset_title) - %(letter). %(problem_title)",
  problemSolutionNotVisible: "You don't have permission to view the problem's solution. Try solving the problem first.",
  problemSolutionSystemInMaintainance: "The functionality to view problem solutions is under maintenance.\n\nWe will be back soon.",
  problemStatusAttempted: "Attempted",
  problemStatusSolved: "Solved",
  problemStatusUnattempted: "Unattempted",
  problemSuccessfullyAdded: "Problem successfully added",
  problemSuccessfullyRemoved: "Problem successfully removed",
  problemSuccessfullyUpdated: "Problem successfully updated",
  problemTagAnalysisOfRecurrences: "Analysis of recurrences",
  problemTagAnalyticGeometry: "Analytic geometry",
  problemTagArithmetic: "Arithmetic",
  problemTagArrays: "Arrays",
  problemTagBOI: "BOI",
  problemTagBacktracking: "Backtracking",
  problemTagBigData: "Big data",
  problemTagBigNumbers: "Big numbers",
  problemTagBinarySearch: "Binary search",
  problemTagBinarySearchTree: "Binary search tree",
  problemTagBipartiteMatching: "Bipartite matching",
  problemTagBitManipulation: "Bit manipulation",
  problemTagBooleanAlgebra: "Boolean algebra",
  problemTagBreadthFirstSearch: "Breadth-first search",
  problemTagBruteForce: "Brute force",
  problemTagCIIC: "CIIC",
  problemTagCOCI: "COCI",
  problemTagCharsAndStrings: "Chars and strings",
  problemTagChineseRemainderTheorem: "Chinese remainder theorem",
  problemTagCodingCup: "CodingCup",
  problemTagCodingRush: "CodingRush",
  problemTagCombinations: "Combinations",
  problemTagCombinatorialDesigns: "Combinatorial designs",
  problemTagConditionals: "Conditionals",
  problemTagConvexHull: "Convex hull",
  problemTagCountingProblems: "Counting problems",
  problemTagDataCompression: "Data compression",
  problemTagDepthFirstSearch: "Depth-first search",
  problemTagDiophantineEquations: "Diophantine equations",
  problemTagDirectedGraphs: "Directed graphs",
  problemTagDisjointSets: "Disjoint sets",
  problemTagDivideAndConquer: "Divide and conquer",
  problemTagDivisibilityRules: "Divisibility rules",
  problemTagDynamicProgramming: "Dynamic programming",
  problemTagExponentialSearch: "Exponential search",
  problemTagExponentiationBySquaring: "Exponentiation by squaring",
  problemTagFenwickTrees: "Fenwick trees",
  problemTagFileSeeking: "File seeking",
  problemTagFormattedInputAndOutput: "Formatted input and output",
  problemTagFourierTransformation: "Fourier transformation",
  problemTagFunctions: "Functions",
  problemTagGCDAndLCM: "Common multiples and divisors",
  problemTagGameTheory: "Game theory",
  problemTagGeneticAlgorithms: "Genetic algorithms",
  problemTagGraphConnectivity: "Graph connectivity",
  problemTagGraphRepresentation: "Graph representation",
  problemTagGraphsWithNegativeWeights: "Graphs with negative weights",
  problemTagGreedyAlgorithms: "Greedy algorithms",
  problemTagHashing: "Hashing",
  problemTagHeaps: "Heaps",
  problemTagHeuristics: "Heuristics",
  problemTagICPC: "ICPC",
  problemTagIOI: "IOI",
  problemTagImplementation: "Implementation",
  problemTagIncrementalSearch: "Incremental search",
  problemTagInputAndOutput: "Input and output",
  problemTagInvertedIndices: "Inverted indices",
  problemTagLazyPropagation: "Lazy propagation",
  problemTagLeastCommonAncestor: "Least common ancestor",
  problemTagLexingAndParsing: "Lexing and parsing",
  problemTagLinearSearch: "Linear Search",
  problemTagLinkedLists: "Linked lists",
  problemTagLocalSearch: "Local search",
  problemTagLoops: "Loops",
  problemTagMapsMultimaps: "Maps and multimaps",
  problemTagMatrices: "Matrices",
  problemTagMaxFlow: "Max flow",
  problemTagMeetInTheMiddle: "Meet in the middle",
  problemTagMemorization: "Memorization",
  problemTagMinimumSpanningTrees: "Minimum spanning trees",
  problemTagModularArithmetic: "Modular arithmetic",
  problemTagModularMultiplicativeInverse: "Modular multiplicative inverse",
  problemTagMonotoneStack: "Monotone stack",
  problemTagNearestNeighbors: "Nearest neighbors",
  problemTagNumberTheory: "Number theory",
  problemTagNumericalMethods: "Numerical methods",
  problemTagNumericalSeries: "Numerical series",
  problemTagOFMI: "OFMI",
  problemTagOMI: "OMI",
  problemTagOMIAguascalientes: "OMI Aguascalientes",
  problemTagOMIBajaCalifornia: "OMI Baja California",
  problemTagOMIBajaCaliforniaSur: "OMI Baja California Sur",
  problemTagOMICampeche: "OMI Campeche",
  problemTagOMIChiapas: "OMI Chiapas",
  problemTagOMIChihuahua: "OMI Chihuahua",
  problemTagOMICoahuila: "OMI Coahuila",
  problemTagOMIColima: "OMI Colima",
  problemTagOMIDistritoFederal: "OMI Distrito Federal",
  problemTagOMIDurango: "OMI Durango",
  problemTagOMIGuanajuato: "OMI Guanajuato",
  problemTagOMIGuerrero: "OMI Guerrero",
  problemTagOMIHidalgo: "OMI Hidalgo",
  problemTagOMIJalisco: "OMI Jalisco",
  problemTagOMIMexico: "OMI M\u00e9xico",
  problemTagOMIMichoacan: "OMI Michoac\u00e1n",
  problemTagOMIMorelos: "OMI Morelos",
  problemTagOMINayarit: "OMI Nayarit",
  problemTagOMINuevoLeon: "OMI Nuevo Le\u00f3n",
  problemTagOMIOaxaca: "OMI Oaxaca",
  problemTagOMIPS: "OMIPS",
  problemTagOMIPuebla: "OMI Puebla",
  problemTagOMIQueretaro: "OMI Quer\u00e9taro",
  problemTagOMIQuintanaRoo: "OMI Quintana Roo",
  problemTagOMISanLuisPotosi: "OMI San Luis Potos\u00ed",
  problemTagOMISinaloa: "OMI Sinaloa",
  problemTagOMISonora: "OMI Sonora",
  problemTagOMITabasco: "OMI Tabasco",
  problemTagOMITamaulipas: "OMI Tamaulipas",
  problemTagOMITlaxcala: "OMI Tlaxcala",
  problemTagOMIVeracruz: "OMI Veracruz",
  problemTagOMIYucatan: "OMI Yucat\u00e1n",
  problemTagOMIZacatecas: "OMI Zacatecas",
  problemTagOfflineQueries: "Offline queries",
  problemTagPalindromeAlgorithms: "Palindrome algorithms",
  problemTagPartialSums: "Partial sums",
  problemTagParticleSwarmOptimization: "Particle swarm optimization",
  problemTagPermutations: "Permutations",
  problemTagPrimalityTest: "Primality test",
  problemTagPrimeFactorization: "Prime factorization",
  problemTagPrimeGeneration: "Prime generation",
  problemTagProbabilityAndStatistics: "Probability and statistics",
  problemTagQueues: "Queues",
  problemTagRecursion: "Recursion",
  problemTagSQRTDecomposition: "SQRT decomposition",
  problemTagSegmentTrees: "Segment trees",
  problemTagSetsMultisets: "Sets and multisets",
  problemTagShortestPaths: "Shortest paths",
  problemTagSimulation: "Simulation",
  problemTagSlidingWindow: "Sliding window",
  problemTagSorting: "Sorting",
  problemTagStacks: "Stacks",
  problemTagStringMatching: "String matching",
  problemTagSubArraySearch: "Subarray search",
  problemTagSubsequenceSearch: "Subsequence search",
  problemTagSuffixTrees: "Suffix trees",
  problemTagSweepLine: "Sweep Line",
  problemTagSystemsOfEquations: "Systems of equations",
  problemTagTopologicalSorting: "Topological sorting",
  problemTagTreeTransversal: "Tree traversal",
  problemTagTrees: "Trees",
  problemTagTries: "Tries",
  problemTagTwoPointersTechnique: "Two pointers technique",
  problemTagUnformattedInputAndOutput: "Unformatted input and output",
  problemTagWaveletTrees: "Wavelet trees",
  problemTagsLockedByPreferences: "To show problem tags, please update your preferences in your profile.",
  problemTitleExists: "Problem title already exists. Please try a different one.",
  problemVersionCurrentVersion: "Current version",
  problemVersionDate: "Commit date",
  problemVersionDiffMode: "Show diff",
  problemVersionDiffModeFiles: "Files",
  problemVersionDiffModeNone: "None",
  problemVersionDiffModeSubmissions: "Submissions",
  problemVersionMessage: "Commit message",
  problemVersionNewVersion: "New version",
  problemVersionNotFound: "Problem version not found.",
  problemVersionPublishedRevision: "Published",
  problemVersionShowOnlyChanges: "Only show changes",
  problemVersionUpdate: "Update problem version",
  problemVersionUpdatePublishedEditableProblemsets: "Update currently running contests / assignments / exams that I manage",
  problemVersionUpdatePublishedNonProblemset: "Do not update contests / assignments / exams",
  problemVersionUpdatePublishedOwnedProblemsets: "Update currently running contests / assignments / exams that I own",
  problemVersionUpdated: "Problem version updated.",
  problemVersionUsername: "Account name",
  problemVersionVersion: "Problem version",
  problemWarningBecause: "This problem has been marked with a warning because:",
  problemcollectionViewProblems: "View problems",
  problemlessGrader: "omegaUp IDE",
  problemsOrderUpdated: "Problems' order has been updated",
  problemsetIdentityNotFound: "Account or identity is not associated with this course, contest or task.",
  problemsetNotFound: "Problemset does not exist.",
  profile: "Name",
  profileAboutSection: "About Me",
  profileAboutSectionAddPrompt: "Add a section to tell visitors about yourself.",
  profileAboutSectionReport: "Report profile",
  profileAboutSectionReportSuccess: "Report submitted. Thank you.",
  profileAddIdentitiesTooltip: "Add identities using their omegaUp account name",
  profileApiTokensEmpty: "No API tokens",
  profileAttemptingProblems: "Attempting",
  profileAuthorRank: "Author rank",
  profileBasicInformation: "Basic information",
  profileBookmarkedProblems: "Bookmarked problems",
  profileContests: "Contests results",
  profileContestsTableContest: "Contest",
  profileContestsTablePlace: "Place",
  profileCountry: "Country / Region",
  profileCreatedContent: "Created content",
  profileCreatedContentSeeAll: "See all",
  profileCreatedContests: "Created contests",
  profileCreatedCourses: "Created courses",
  profileCreatedProblems: "Created problems",
  profileDifficultyProgress: "%(difficulty)s: %(count)s/%(total)s",
  profileEasy: "Easy",
  profileEdit: "Edit profile",
  profileEmail: "Email",
  profileGraduationDate: "Graduation date",
  profileHard: "Hard",
  profileIdentitiesEmpty: "No identities",
  profileIdentityAdded: "Identity added successfully",
  profileImageAltGeneric: "Profile image",
  profileImageAltWithUsername: "Profile image of %(username)",
  profileIsPrivate: "This profile is private",
  profileManageApiTokens: "Manage API tokens",
  profileManageIdentities: "Manage identities",
  profileMedium: "Med.",
  profileName: "Name",
  profileNoTagsData: "No tags data available",
  profileOrganizedContests: "Organized contests",
  profilePersonalData: "Personal data",
  profilePrivateRankMessage: "When you enable this option, your account ranking will not be visible.",
  profilePrivateRankMessageTitle: "Warning",
  profileProblemProgress: "Problem Progress",
  profileProblemsCount: "problems",
  profileRank: "Coder rank",
  profileRankBeginner: "\u03bf",
  profileRankExpert: "\u0398",
  profileRankInternationalMaster: "\u03c9",
  profileRankMaster: "\u03a9",
  profileRankSpecialist: "\u039f",
  profileRankUnrated: "Unrated",
  profileSchool: "School",
  profileSchoolMonthlySolvedProblemsCount: "Monthly solved problems count for the users of %(school)",
  profileSolvedProblems: "Solved problems",
  profileState: "State",
  profileStatistics: "Stats",
  profileStatisticsCumulative: "Cumulative",
  profileStatisticsDay: "Day",
  profileStatisticsDelta: "Delta",
  profileStatisticsMonth: "Month",
  profileStatisticsNumberOfSolvedProblems: "Number of solved problems",
  profileStatisticsPeriod: "Period",
  profileStatisticsRuns: "<b>Runs</b>",
  profileStatisticsTotal: "Total",
  profileStatisticsVerdictsOf: "Verdicts of %(user)",
  profileStatisticsWeek: "Week",
  profileStatisticsYear: "Year",
  profileTagsSolved: "Tags Solved",
  profileUnlabelled: "Unlabelled",
  profileUnsolvedProblems: "Problems tried (but not solved)",
  profileUsername: "Account name",
  publicCourseCardMetricsLessons: "%(lessonCount) lessons",
  publicCourseCardMetricsOneLesson: "1 lesson",
  publicCourseCardMetricsOneStudent: "1 student",
  publicCourseCardMetricsStudents: "%(studentCount) students",
  publicCourseInformationDescription: "On-demand courses that omegaUp offers for free.",
  publicTagsPlaceholder: "Ex. Recursion, Segment Trees, Binary Search",
  qualityFormCongrats: "Congratulations for solving this problem!",
  qualityFormDifficulty: "How difficult did you find this problem?",
  qualityFormDifficultyAny: "Any",
  qualityFormDifficultyEasy: "Easy",
  qualityFormDifficultyHard: "Hard",
  qualityFormDifficultyMedium: "Medium",
  qualityFormDifficultyVeryEasy: "Very easy",
  qualityFormDifficultyVeryHard: "Very hard",
  qualityFormQuality: "How good would you say this problem is?",
  qualityFormQualityAny: "Any problem",
  qualityFormQualityBad: "Bad",
  qualityFormQualityFair: "Fair",
  qualityFormQualityGood: "Good",
  qualityFormQualityOnly: "Quality problems only",
  qualityFormQualityVeryBad: "Very bad",
  qualityFormQualityVeryGood: "Very good",
  qualityFormRateBeforeAc: "You can already rate this problem!",
  qualityFormThanksForReview: "Thanks for review!",
  qualityNominationCreatedBy: "Created by",
  qualityNominationListEmptyDescription: "There are no quality nominations to review at this moment.",
  qualityNominationListEmptyTitle: "No quality nominations to review",
  qualityNominationMustHaveSolvedProblem: "You must solve a problem before nominating it",
  qualityNominationMustHaveTriedToSolveProblem: "You must have tried to solve the problem before nominating it",
  qualityNominationMustNotHaveSolvedProblem: "You must not have solved the problem for 'before_ac' nominating it",
  qualityNominationNominatedBy: "Nominated by",
  qualityNominationNotFound: "Nomination not found",
  qualityNominationProblemHasBeenBanned: "This problem has been banned. You cannot update its visibility.",
  qualityNominationProblemHasBeenPromoted: "This problem has been promoted. You cannot update its visibility.",
  qualityNominationProblemHasWarning: "This problem has a warning. You cannot update its visibility.",
  qualityNominationRateProblem: "Rate problem",
  qualityNominationRateProblemDesc: "If you want to rate the problem later, click on \"Rate problem\" link",
  qualityNominationResolutionSuccess: "Quality nomination successfully resolved.",
  qualityNominationShowAll: "Also show resolved nominations",
  qualityNominationType: "Type",
  rankRangeHeader: "Coders with the most points (%(lowCount) to %(highCount))",
  rankScore: "Score",
  rankSeeGeneralRanking: "See the general ranking",
  rankSolved: "Solved problems",
  rankingNoUsers: "We don't have data to display on the Ranking graph.",
  recordNotFound: "Record not found.",
  redisAuthenticationFailed: "Redis authentication failed",
  redisConnectionFailed: "Failed to connect to Redis at %(host):%(port)",
  registerForContest: "Register for contest",
  registerForContestChallenges: "Challenge",
  registerForContestRules: "Rules",
  registerForCourse: "Register for course",
  registrationDenied: "Your request to join this contest has been denied!",
  registrationPending: "Your request to join this contest is pending approval from the contest admin.",
  registrationPendingCourse: "Your request to join this course is pending approval from the admin.",
  registrationRejectionFeedback: "The reason provided by the admin was: %(extra_note)",
  reportAnIssue: "Report an issue",
  reportAnIssueTemplate: "## Expected Behavior\n\n*Describe what you expected to happen*\n\n## Actual Behavior\n\n*Describe what happened instead of what you expected*\n\n## Possible Solution\n\n*Not required, but if you can think of something, you can suggest a way to fix the bug.*\n\n## Reproduction steps\n\n*Provide a detailed list of steps of what you did to reproduce\nthis bug.  Include the code that reproduces it, if it is relevant.*\n\n1. \n2. \n3. \n4. \n\n## Context\n\n*How has this issue affected you? What were you trying to achieve?*\n\n*Providing context helps us to find the right solution and priority.*\n\n## Your environment\n\n*Include the relevant details about the environment in which this bug was reproduced*\n\n* Browser name (e.g. Chrome 39, node.js 5.4): %(userAgent)\n* Link to the site where this problem occurs: %(referer)\n* Console errors: %(serializedErrors)\n* Screen capture:",
  reportProblemFormAdditionalComments: "Additional comments (optional):",
  reportProblemFormCases: "I believe the test cases are wrong.",
  reportProblemFormDuplicate: "This is a duplicated problem.",
  reportProblemFormLinkToOriginalProblem: "Link to original problem (required):",
  reportProblemFormNotAProblemStatement: "Does not describe a problem statement.",
  reportProblemFormOffensive: "Is offensive.",
  reportProblemFormOtherReason: "Other reason.",
  reportProblemFormPoorlyDescribed: "The problem is poorly described.",
  reportProblemFormQuestion: "Why do you want to report this problem?",
  reportProblemFormSpam: "Is Spam.",
  reportProblemFormThanksForReview: "Thanks for your report!",
  requestCoder: "Coder",
  requestDate: "Date of request",
  requestFeedback: "The feedback request has been sent to all the administrators.",
  requestFeedbackConfirm: "Do you want to request feedback for this submission?",
  requestFeedbackMessage: "I need your help in this submission.",
  resetTemplate: "Reset to template",
  resetToDefault: "Reset to default code definition",
  resourceNotFound: "Resource not found.",
  reviewerNomination: "Rate problem as reviewer",
  reviewerNominationFormTitle: "Qualify this problem!",
  reviewerNominationQuality: "Is this a quality problem?",
  runCannotBeDisqualified: "The run cannot be disqualified",
  runCannotBeRequalified: "The run cannot be requalified",
  runDetailsCompilationError: "Compilation error",
  runDetailsCorrect: "Correct",
  runDetailsExceeded: "Limit exceeded",
  runDetailsFeedbackAddReview: "Add feedback",
  runDetailsFeedbackCancel: "Cancel",
  runDetailsFeedbackPlaceholder: "Type your feedback here...",
  runDetailsFeedbackThreadPlaceholder: "Reply...",
  runDetailsFinished: "Finished",
  runDetailsIncorrect: "Incorrect",
  runDetailsInterrupted: "Interrupted",
  runDetailsJudgeError: "Judge error",
  runDetailsNewFeedback: "New feedback",
  runDetailsNotAvailable: "Not available",
  runDetailsRuntimeError: "Runtime error",
  runDetailsRuntimeFunctionError: "Restricted function error",
  runDetailsValidatorError: "Validator error",
  runDisqualifyByProblemConfirm: "Do you really want to disqualify all runs for this problem in the contest for this user?",
  runDisqualifyByUserConfirm: "Do you really want to disqualify all the contest runs for this user?",
  runDisqualifyConfirm: "Do you really want to disqualify this run?",
  runGUID: "GUID",
  runNotEvenOpened: "You must open the problem before trying to submit a solution.",
  runNotFound: "Run not found.",
  runNotInsideContest: "Contest time has expired or not started yet.",
  runWaitGap: "You have to wait between consecutive submissions.",
  runsListEmptyDescription: "There are no runs to show at this moment.",
  runsListEmptyTitle: "No runs to show",
  schoolNotFound: "School not found",
  schoolNotSelected: "No school selected",
  schoolOfTheMonth: "School of the Month",
  schoolOfTheMonthAlreadySelected: "School of the month has been previously selected",
  schoolOfTheMonthChooseAsSchool: "Choose as School of the Month",
  schoolOfTheMonthIsNotInPeriodToBeChosen: "School of the month is not in the period to be chosen",
  schoolOfTheMonthNotFound: "School of the month not found.",
  schoolOfTheMonthSelectedSuccessfully: "School of the month has been selected successfully!",
  schoolOfTheMonthSystemInMaintainance: "The School of the Month system is under maintenance.\n\nWe will be back soon.",
  schoolRankOfTheMonthHeader: "Top %(count) schools with the most points in the month",
  schoolRankRangeHeader: "Schools with the most points (%(lowCount) to %(highCount))",
  schoolUsers: "Users who belong to this school",
  schoolsCreateCoursesThatMeetNeeds: "Courses that meet your needs. You can create your own problems.",
  schoolsCreateYourCourse: "Create your courses",
  schoolsCreateYourProblems: "Create your problems",
  schoolsLearnProgBySolvProblems: "Learn programming by solving problems",
  schoolsManageProgressOfStudents: "Manage the progress of your students",
  schoolsOfTheMonth: "Schools of the Month",
  schoolsOfTheMonthCandidates: "Candidates to School of the Month",
  schoolsOfTheMonthRank: "Top 100 schools of previous month",
  schoolsStartUsingCourses: "Start using Courses",
  scoreboardAccountName: "Account name",
  scoreboardFirstSolvedTooltip: "First solved by %(username) at %(time)",
  scoreboardLastUpdated: "Last time updated: %(datetime)",
  scoreboardNameAndAccountName: "Name and account name",
  scoreboardShowOnlyInvitedIdentities: "Show official contestants only",
  scoreboardShowParticipantsNames: "Show participants' names",
  scoreboardSolvedCountTooltip: "Contestants who solved this problem",
  scoreboardSolvedRowTitle: "Solved",
  searchSchool: "Search school",
  searchUser: "Search coder",
  selectProblemLevelDesc: "In order to add the problem, you must to choose its corresponding level",
  selectTwoUsersToCompare: "Select two users to compare",
  selectUserForComparison: "Select %(username) for comparison",
  serviceUnavailableError: "Oops. The service is currently unavailable. Please try again.",
  settingsExtraWallTime: "Extra Wall Time",
  settingsInteractive: "Interactive",
  settingsLanguage: "Programming Language",
  settingsMemoryLimit: "Memory Limit",
  settingsModuleName: "Module Name",
  settingsOutputLimit: "Output Limit",
  settingsOverallWallTimeLimit: "Wall Time Limit (Total)",
  settingsTimeLimit: "Time Limit",
  settingsTolerance: "Tolerance",
  settingsValidator: "Validator",
  showDefaultAllContestantsInScoreboard: "Show all contestants on the scoreboard by default.",
  showLinks: "Links",
  showTotalScoreboard: "Show total scoreboard",
  signUpFormInteractiveGuideConfirmPassword: "Confirm your password",
  signUpFormInteractiveGuideEmail: "Enter your email",
  signUpFormInteractiveGuidePassword: "Create your password, 8 characters minimum",
  signUpFormInteractiveGuideRegister: "Click here",
  signUpFormInteractiveGuideTermsAndConditions: "Please read and accept our terms and conditions",
  signUpFormInteractiveGuideTitle: "Sign Up",
  signUpFormInteractiveGuideUsername: "Create your account name, only uppercase letters, lowercase letters, numbers, the characters _, . and - are allowed, the minimum number of characters is 2.",
  signUpFormInteractiveGuideWelcome: "Let's create your account! \ud83d\udc4b",
  singleUserAddSuccess: "Account successfully added",
  socketStatusConnected: "Socket is connected",
  socketStatusFailed: "Socket connection failed",
  socketStatusWaiting: "Waiting for socket connection",
  solutionAvailableViews: "See available views",
  solutionConfirm: "Please click on the button to see this solution.",
  solutionLocked: "You can't see this solution yet.\n\n*   Try solving the problem first or you can unlock it if you have not yet reached the limit of solutions seen per day.\n*   Once you decide to unlock the solution for a problem, it won't count towards your score for omegaUp's ranking.",
  solutionNotFound: "There isn't any solution for this problem.",
  solutionNotLoggedIn: "You must login to unlock/see this solution.",
  solutionViewsLeft: "You have **%(available)** available views left, out of a total of **%(total)** that you can make per day.",
  spinnerLoadingMessage: "Loading...",
  startContest: "Start Contest",
  startCourse: "Start Course",
  statementLanguage: "Language",
  statementLanguageEn: "English",
  statementLanguageEs: "Spanish",
  statementLanguagePt: "Portuguese",
  statementNotFound: "Problem statement not found.",
  studentCourseInformationDescription: "Here you will find the list of courses that you are enrolled in.",
  studentProgressDescriptionTotalPoints: "(%(points) points + %(extraPoints) extra)",
  studentProgressExtraProblem: "(extra)",
  studentProgressOnlyLecturesDescription: "This content only includes lectures",
  studentProgressPoints: "(%(points) points)",
  studentProgressTooltipDescription: "%(problem):\n\n%(score) of %(points) points (%(progress)% progress)",
  studentsProgressRangeHeader: "Students progress (from %(lowCount) to %(highCount))",
  submissionFeedbackAlreadyExists: "The feedback for this submission already exists.",
  submissionFeedbackAnimationButton: "Leave your feedback line by line as shown in the animation:",
  submissionFeedbackDemoAlt: "Submission feedback demo",
  submissionFeedbackParticipantsListEmpty: "The list of participants in this thread is empty",
  submissionFeedbackSendButton: "Leave feedback \ud83d\udd3d",
  submissionMemoryInMegabytes: "%(value) MiB",
  submissionNotFound: "Submission not found.",
  submissionRunTimeInSeconds: "%(value) s",
  submissionSendFeedback: "Send feedback",
  submissionsListCoder: "Coder",
  submissionsListTitle: "Submissions in the last 24 hours",
  submitFeedbackCancel: "Cancel",
  submitFeedbackPlaceholder: "Enter your feedback (optional)",
  submitFeedbackRequireConfirmation: "Submit feedback",
  submitFeedbackSubmit: "Submit",
  supportAssignUserRoles: "Assign roles",
  supportContestRemovedFromRecommended: "Contest has been removed from recommended",
  supportContestSetAsRecommended: "Contest has been set as recommended",
  supportNewSearch: "New search",
  supportOptions: "Options",
  supportSetAsRecommended: "Set as recommended",
  supportTypeContestAlias: "Type contest alias",
  supportTypeEmailOrUsername: "Type email or username",
  switchLanguage: "Switch",
  tagAdded: "Tag successfully added!",
  tagNotFound: "Tag not found",
  tagPrefixRestricted: "The 'problemTag' prefix can't be used for tags added manually.",
  tagRemoved: "Tag successfully removed!",
  tagRestricted: "Tag cannot be added or removed.",
  tagSourceLevel: "Level",
  tagSourceOwner: "Author's tag",
  tagSourceVoted: "Coders' tag",
  teamAliasInUse: "There is at least one duplicate team alias. Please check the CSV file to fix the information.",
  teamMemberExceededNumberOfContestants: "The number of contestants in one of the teams exceeds the maximum allowed",
  teamMemberUsernameInUse: "There is at least one duplicate account name in the teams of the group. Please fix the information.",
  teamsGroupAliasMustBeRequired: "In a contest for teams, alias must be required",
  teamsGroupArchiveConfirmText: "Are you sure you want to archive this team group?",
  teamsGroupArchivedSuccess: "Team group archived successfully.",
  teamsGroupCreateIdentitiesAsTeams: "Create identities as teams",
  teamsGroupCreatingIdentitiesAsTeams: "Creating identities as teams",
  teamsGroupEditGroupUpdated: "The teams group has been successfully updated.",
  teamsGroupEditTeams: "Teams",
  teamsGroupEditTeamsPasswordUpdated: "Password successfully updated!",
  teamsGroupEditTeamsRemoved: "Team successfully removed!",
  teamsGroupEditTeamsUpdated: "Team successfully updated!",
  teamsGroupEditTitleWithName: "Edit teams group %(name)",
  teamsGroupEmptyDescription: "Create your first teams group to start organizing your teams.",
  teamsGroupEmptyTitle: "No teams groups yet",
  teamsGroupFormCreate: "Create teams group",
  teamsGroupFormUpdate: "Update teams group",
  teamsGroupMemberChangePassword: "Type the new password",
  teamsGroupMembersAccountName: "Account name",
  teamsGroupNewFormDescription: "Teams group description",
  teamsGroupShowArchived: "Show archived",
  teamsGroupTeamName: "Team name",
  teamsGroupTeamsAdvancedOptions: "Advanced options",
  teamsGroupTeamsEmptyList: "No teams in this group",
  teamsGroupTeamsGroupName: "Teams group name",
  teamsGroupTeamsSelfGenerateIdentities: "Self-generate identities",
  teamsGroupUnarchiveConfirmText: "Are you sure you want to unarchive this team group?",
  teamsGroupUnarchivedSuccess: "Team group unarchived successfully.",
  teamsGroupUploadIdentitiesAsTeams: "Upload teams",
  teamsGroupUsernames: "Coders",
  teamsGroupsCanNotBeAddedInNormalContest: "Teams groups cannot be added in normal contests",
  teamsGroupsCreateNew: "Create new teams group",
  teamsGroupsCsvHelp: "## Quickly add multiple identities as teams to this teams group. Identities are not regular accounts, and don't need to have an email or validate their account.\n\n## Identities should be in a `.csv` file with the following format:\n```\nusername,name,country_id,state_id,gender,school_name\nteam-1,Team 1,MX,AGU,other,Best School\nteam-2,Teams 2,MX,AGU,decline,Best School\n```",
  teamsGroupsCsvHelpMoreInfo: "\u2139\ufe0f More info",
  teamsGroupsErrorFieldIsNotPresentInCsv: "Some required fields were not found in csv file: %(missingFields)",
  teamsGroupsErrorFieldIsRequired: "The field %(field) is required.",
  titleInUse: "Title already exists. Please choose a different title.",
  tokenDecodeCorrupted: "There was a problem decoding the token.",
  tokenDecodeExpired: "The token has already expired.",
  tokenDecodeInvalid: "The token does not belong this course.",
  tokenDecodeUnknown: "The token is not valid for this course.",
  totalRuns: "Total runs: %(numRuns)",
  typeaheadSearchPlaceholder: "Search...",
  unableToUpdateTAEnabledField: "Unable to update AI Teaching Assistant status. Please try again.",
  unableToVerifyCaptcha: "We failed to verify the captcha. Please reload the page and try again.",
  under13UserException: "You can't access this site from an account for children under 13 years of age",
  unnecessaryTokenForPublicCourses: "Token is unnecessary for public courses",
  unsupportedBrowser: "Your browser doesn't support all the features on this page. Please try to update to a [supported browser](https://github.com/omegaup/omegaup#supported-browsers).",
  unverifiedUser: "Unverified account.",
  updateItemsSuccess: "All the selected items has been updated",
  updateProblemLevel: "Update problem level",
  updateStatementsCommitMessage: "Updated statements",
  userAlreadyAcceptedPrivacyPolicy: "This account has already accepted the privacy policy",
  userAlreadyHasSelectedRole: "This account already has the selected role",
  userBirthDate: "Birth date: %(birthDate)",
  userDocsDocumentation: "Documentation",
  userDoesNotHaveAnyPasswordChangeRequest: "The account does not have any password change request in the last 24 hours.",
  userEditAddPassword: "Add password",
  userEditBachelors: "Bachelor's",
  userEditBirthDate: "Birth date",
  userEditChangeEmail: "Change email",
  userEditChangePassword: "Change password",
  userEditChangePasswordNewPassword: "New password",
  userEditChangePasswordOldPassword: "Old password",
  userEditChangePasswordRepeatNewPassword: "Repeat new password",
  userEditChangePasswordToUsername: "Change password: %(username)",
  userEditCodeTemplates: "Code templates",
  userEditCountry: "Country / Region",
  userEditDeleteAccount: "Delete Account",
  userEditDoctorate: "Doctorate",
  userEditEarlyChildhood: "Early childhood",
  userEditGraduationDate: "Graduation date",
  userEditGravatar: "Upload in Gravatar.com using your email: ",
  userEditHideProblemTags: "Hide problems tags",
  userEditLanguage: "Language",
  userEditLowerSecondary: "Middle school / Junior high",
  userEditManageSchools: "Manage schools",
  userEditManageSchoolsUserCurrentlyEnrolled: "Currently enrolled",
  userEditMaster: "Masters",
  userEditNameTooLong: "Name can't exceed 50 caracters in length.",
  userEditNone: "None",
  userEditPostSecondary: "Career / technical institution",
  userEditPrePrimary: "Pre-primary",
  userEditPreferences: "Preferences",
  userEditPreferencesSuccess: "Preferences successfully updated.",
  userEditPreferredProgrammingLanguage: "Preferred programming language",
  userEditPreferredProgrammingLanguagePlaceholder: "Choose the language",
  userEditPrimary: "Elementary",
  userEditPrivateProfile: "Would you like to hide profile details from others?",
  userEditProfileImage: "Profile image",
  userEditSchoolGrade: "School grade",
  userEditSchoolSuccess: "School's information successfully updated.",
  userEditShowProblemTags: "Show problem tags",
  userEditSuccess: "Profile successfully updated.",
  userEditSuccessfulEmailUpdate: "Email updated successfully! In a few minutes, you will receive more instructions in your email. Don't forget to check your Spam folder.",
  userEditTertiary: "Community College",
  userEditUpperSecondary: "Senior High / High school",
  userEditViewProfile: "View my profile",
  userEmailEditEmail: "Email",
  userEmails: "E-mails",
  userEndTimeUpdatedSuccessfully: "Contest end time has been updated successfully.",
  userGroups: "Groups",
  userHeatmapCurrentStreak: "Current streak",
  userHeatmapMaxStreak: "Max streak",
  userHeatmapSubmissionsInYear: "Accepted submissions in %(year)",
  userHeatmapTotalActiveDays: "Total active days",
  userInformationIsPrivate: "The account's information is private",
  userLastLogin: "Last login: %(lastLogin)",
  userNeverLoggedIn: "Has never logged in.",
  userNextRegisteredContestButtonEnter: "Enter",
  userNextRegisteredContestButtonSeeDetails: "See details",
  userNextRegisteredContestTitle: "Remember to participate in the contest",
  userNotAllowed: "You do not have the permits to perform this action.",
  userNotAllowedToAddPrivateProblem: "Only problem admins are allowed to add their own private problems in problemsets",
  userNotExist: "Account does not exist.",
  userNotInListOfRequests: "This account does not have a pending request.",
  userObjectivesModalAnswerCompetitive: "programming contests",
  userObjectivesModalAnswerLearning: "learn programming",
  userObjectivesModalAnswerLearningAndTeaching: "learn and teach programming",
  userObjectivesModalAnswerNone: "none of the above",
  userObjectivesModalAnswerOther: "other",
  userObjectivesModalAnswerScholar: "school classes",
  userObjectivesModalAnswerScholarAndCompetitive: "classes and contests",
  userObjectivesModalAnswerTeaching: "teach programming",
  userObjectivesModalButtonNext: "Next",
  userObjectivesModalButtonPrevious: "Previous",
  userObjectivesModalButtonSend: "Send",
  userObjectivesModalDescriptionLearning: "I want to learn for ...",
  userObjectivesModalDescriptionLearningAndTeaching: "I want to learn and teach for ...",
  userObjectivesModalDescriptionTeaching: "I want to teach for ...",
  userObjectivesModalDescriptionUsage: "I want to use omegaUp to ...",
  userObjectivesModalPageCounter: "%(current) of %(last)",
  userObjectivesModalTitle: "Help us to get to know you",
  userObjectivesUpdateSuccess: "Thanks for helping us. Your answers have been saved",
  userOrMailNotFound: "Account name or email not found.",
  userPasswordMustBeSame: "The new passwords must be the same.",
  userProfileIsPrivate: "This account's profile is marked private; some information will not be displayed",
  userProfileProblemsFilter: "Filter",
  userRankEmptyList: "There is not data to show in the ranking",
  userRankLastUpdated: "Last updated: %(datetime)",
  userRankOfTheMonthHeader: "%(count) coders with the most points in the month",
  userRankSolvedProblemsHelp: "The number of solved problems is updated once a day.",
  userRemoveSuccess: "Account successfully removed!",
  userRoles: "Roles",
  userVerified: "Account has been verified",
  userVerify: "Verify account",
  username: "Account name",
  usernameInUse: "This account name has already been used.",
  usernameOrPassIsWrong: "Account name or password are wrong. Please check your credentials.",
  usersCanNotBeAddedInContestForTeams: "Individual accounts cannot be added in contests for teams",
  usersCanNotBeAddedInVirtualContestWhenOriginalContestIsPrivate: "Coders can not be added in virtual contest when original contest is private",
  verdictAC: "Accepted",
  verdictCE: "Compilation error",
  verdictFO: "Runtime error (restricted function)",
  verdictHelpAC: "Your program is correct!",
  verdictHelpCE: "Your program failed to compile. Please click on the \"Details\" button to see the compilation error.",
  verdictHelpDisqualified: "A judge has manually disqualified this submission",
  verdictHelpFO: "Your program tried to perform an operation not allowed by the sandbox. Typically this is caused by calling system().",
  verdictHelpJE: "Something went wrong on our end, and it's not your fault. Someone has been notified and should be fixed shortly. Please do not re-submit since you will only make the problem worse and might be penalized.",
  verdictHelpKarelRTE: "Karel crashed into a wall, or ran out of beepers.",
  verdictHelpKarelTLE: "Karel made too many steps.",
  verdictHelpML: "Your program tried to use more memory than what the problem allows. Try thinking of an algorithm that uses less memory.",
  verdictHelpMLE: "Your program tried to use more memory than what the problem allows. Try thinking of an algorithm that uses less memory.",
  verdictHelpOL: "Your program produced an answer that is wrong in at least one case. As a hint, you tried to print way too much output.",
  verdictHelpOLE: "Your program produced an answer that is wrong in at least one case. As a hint, you tried to print way too much output.",
  verdictHelpPA: "Your program correctly solved some of the cases, but had at least one wrong case.",
  verdictHelpRE: "Your program terminated unexpectedly (crashed). Most likely you failed to consider at least one possible case. This is typically caused by accessing an invalid element of an array, running out of stack space, or trying to declare an array that is way too big.",
  verdictHelpRFE: "Your program tried to perform an operation not allowed by the sandbox. Typically this is caused by calling system().",
  verdictHelpRTE: "Your program terminated unexpectedly (crashed). Most likely you failed to consider at least one possible case. This is typically caused by accessing an invalid element of an array, running out of stack space, or trying to declare an array that is way too big.",
  verdictHelpTLE: "Your program is too slow and failed to finish within the time limit of the problem.",
  verdictHelpTO: "Your program is too slow and failed to finish within the time limit of the problem.",
  verdictHelpVE: "Something went wrong with the problem's validator, and it may or may not be your fault. Most of the time this happens because your program made something the validator didn't take into account, but you should let the problem writer / contest organizer know about this.",
  verdictHelpWA: "Your program failed to give the correct answer for all cases. Mosty likely you failed to consider some possible cases.",
  verdictJE: "Judge error (do not re-submit)",
  verdictML: "Memory limit exceeded",
  verdictMLE: "Memory limit exceeded",
  verdictOL: "Wrong answer (output limit exceeded)",
  verdictOLE: "Wrong answer (output limit exceeded)",
  verdictPA: "Partially accepted",
  verdictRE: "Runtime error",
  verdictRFE: "Runtime error (restricted function)",
  verdictRTE: "Runtime error",
  verdictTLE: "Time limit exceeded",
  verdictTO: "Time limit exceeded",
  verdictVE: "Validator error (do not re-submit)",
  verdictWA: "Wrong Answer",
  verificationEmailBody: "Welcome to omegaUp! Please click on the following link to login and verify your email: <a href=\"https://omegaup.com/user/verifyemail/%(verification_id)/\">https://omegaup.com/user/verifyemail/%(verification_id)/</a>",
  verificationEmailSubject: "Welcome to omegaUp!",
  verificationEmailSuccessfully: "Your email address has been verified.",
  verificationIdInvalid: "The provided verification information is not valid.",
  verificationParentalTokenGoToMyDependents: "Go to my dependents",
  viewUnavailableTitle: "This view is currently unavailable",
  virtualContest: "Virtual contest",
  virtualContestSuffix: "%(title) [virtual]",
  virtualSuffix: "%(username) [virtual]",
  virtualTitle: "%(title) - Virtual contest",
  warningPublicSolution: "Warning: The problem you just added has a public solution.",
  wizardDescription: "Follow the steps to find the problems that interest you!",
  wizardLinkText: "Problem Finder",
  wizardPriorityPopularity: "Popularity",
  wizardStepOne: "Choose the themes tag(s)",
  wizardStepThree: "Select your priority",
  wizardStepTwo: "Pick the difficulty range",
  wizardTitle: "Problem Finder",
  wordAccepted: "Accepted",
  wordsActions: "Actions",
  wordsAddAdmin: "Add admin",
  wordsAddIdentity: "Add identity",
  wordsAddLecture: "Add lecture",
  wordsAddMember: "Add member",
  wordsAddProblem: "Add problem",
  wordsAddStudent: "Manage Students",
  wordsAddStudents: "Add students",
  wordsAddTag: "Add Tag",
  wordsAdmin: "Admin",
  wordsAgree: "I agree",
  wordsAlias: "Alias",
  wordsAll: "All",
  wordsAnswer: "Answer",
  wordsAnyLanguage: "Any Language",
  wordsArchive: "Archive",
  wordsArchiveCourse: "Archive course",
  wordsBack: "Back",
  wordsBadgesObtained: "Badges obtained",
  wordsBadgesSeeAll: "See all available badges",
  wordsBanProblem: "Ban problem",
  wordsBannedProblem: "Banned problem",
  wordsBestSolvers: "Best accepted solvers",
  wordsBy: "by",
  wordsCancel: "Cancel",
  wordsCase: "Case",
  wordsCases: "Cases",
  wordsChangedBy: "Changed By",
  wordsClarifications: "Clarification",
  wordsCloneContest: "Clone contest",
  wordsCloneCourse: "Clone course",
  wordsCloneThisCourse: "Clone this course",
  wordsClose: "Close",
  wordsCode: "Code",
  wordsCompilerOutput: "Compiler output",
  wordsCompletedPercentage: "Percentage completed",
  wordsConfirm: "Confirm",
  wordsConsole: "Console",
  wordsContent: "Content",
  wordsContentEdit: "Edit content",
  wordsContentType: "Content type",
  wordsContest: "Contest",
  wordsContests: "Contests",
  wordsContestsResults: "Results",
  wordsCopiedToClipboard: "Copied",
  wordsCopyToClipboard: "Copy to clipboard",
  wordsCountry: "Country",
  wordsCountryRegion: "Country / Region",
  wordsCourseContent: "Course content",
  wordsDangerZone: "Danger Zone",
  wordsDangerZoneDesc: "Delete the problem.\n\nThis can only be done if the problem has not been used in a course or contest.\n\nYou must be very sure that you want to do it, because there is no way to recover it once it is removed.",
  wordsDate: "Date",
  wordsDelete: "Delete",
  wordsDeleted: "Deleted",
  wordsDenied: "Denied",
  wordsDescription: "Description",
  wordsDetailed: "Detailed",
  wordsDetails: "Details",
  wordsDifference: "Difference",
  wordsDifficulty: "Difficulty",
  wordsDownload: "Download",
  wordsDownloadCode: "Download code",
  wordsDownloadDetails: "Download .zip with outputs",
  wordsDownloadOutput: "Download output",
  wordsDueDate: "Due date",
  wordsDuration: "Length",
  wordsEdit: "Edit",
  wordsEditCourse: "Edit course",
  wordsEmpty: "Empty",
  wordsEmptyAddStudentInput: "The input field is empty, please type a account name",
  wordsEnable: "Enable",
  wordsEndTime: "End",
  wordsEndTimeContest: "End time",
  wordsEnglish: "English",
  wordsEphemeralGrader: "Ephemeral Grader",
  wordsExam: "Exam",
  wordsExecution: "Execution",
  wordsExperiments: "Experiments",
  wordsExtraWallTimeMs: "Extra time for libinteractive (ms)",
  wordsFeedback: "Feedback",
  wordsFilterByCountry: "Filter by my country / region",
  wordsFilterByHomework: "Filter by homework",
  wordsFilterByLanguage: "Filter by language",
  wordsFilterByProblem: "Filter by problem",
  wordsFilterBySchool: "Filter by my school",
  wordsFilterByState: "Filter by my state",
  wordsGender: "Gender",
  wordsGenderDecline: "Prefer not to say",
  wordsGenderFemale: "Female",
  wordsGenderMale: "Male",
  wordsGenderOther: "Other",
  wordsGetToKnowOurCourses: "Get to know our courses!",
  wordsGroup: "Group",
  wordsGroupAdmin: "Admin group",
  wordsGroups: "Groups",
  wordsHighQualityProblem: "This problem has been awarded a High Quality badge by a committee of omegaUp reviewers",
  wordsHomework: "Homework",
  wordsID: "ID",
  wordsIdentities: "Identities",
  wordsIdentity: "Identity",
  wordsInOut: "Input/Output",
  wordsInput: "Input",
  wordsJudgedBy: "Judged by",
  wordsJustOutput: "Just output",
  wordsKarel: "Karel",
  wordsKeepProblem: "Keep problem",
  wordsKeyword: "Keyword",
  wordsKeywordSearch: "Search by alias, title or problem id",
  wordsLanguage: "Language",
  wordsLanguages: "Languages",
  wordsLecture: "Lecture",
  wordsLesson: "Lesson",
  wordsLevel: "Level",
  wordsLoading: "Loading",
  wordsLogs: "Logs",
  wordsMember: "Member",
  wordsMemory: "Memory",
  wordsMemoryInMebibytes: "Memory (MiB)",
  wordsMessage: "Message",
  wordsMessageTo: "Message to",
  wordsMonths: "Months",
  wordsMultipleUser: "Multiple accounts (separated by commas or line breaks)",
  wordsMyClarifications: "My clarifications",
  wordsMyContests: "My Contests",
  wordsMyScore: "My score",
  wordsName: "Name",
  wordsNewClarification: "New clarification",
  wordsNewSubmissions: "New submission",
  wordsNext: "Next",
  wordsNextPage: "Next page",
  wordsNo: "No",
  wordsNoComment: "No comment",
  wordsNoSubmissions: "Lecture (No submissions)",
  wordsNone: "None",
  wordsNotApplicable: "N/A",
  wordsNumHomeworks: "Num. of homework assignments",
  wordsNumTests: "Num. of tests",
  wordsNumberOfContestants: "Number of contestants",
  wordsOnlyExamples: "Only examples",
  wordsOptional: "Optional",
  wordsOther: "Other",
  wordsOutOf4: "%(Score) out of 4",
  wordsOutput: "Output",
  wordsOverdue: "Overdue",
  wordsPenalty: "Penalty",
  wordsPending: "Pending",
  wordsPendingRuns: "Pending runs",
  wordsPercentage: "Percentage",
  wordsPoints: "Points",
  wordsPointsDistribution: "Points distribution for contest: %(alias)",
  wordsPointsDistributionInIntervals: "Points distribution in intervals of 100",
  wordsPointsDistributionProblem: "Points distribution for problem: %(alias)",
  wordsPointsForRank: "Points for ranking",
  wordsPointsForRankTooltip: "These points represent the actual value of this problem. Solving it will decrease its value for everyone.",
  wordsPortuguese: "Portuguese",
  wordsPractice: "Practice",
  wordsPrevPage: "Previous page",
  wordsPreview: "Preview",
  wordsPrevious: "Previous",
  wordsPrivacyPolicy: "Privacy Policy",
  wordsPrivacyPolicyAccepted: "You have accepted the privacy policy",
  wordsPrivate: "Private",
  wordsPrivateTags: "Private tags",
  wordsProblem: "Problem",
  wordsProblemOrSolutionNotExist: "The problem or solution don't exist.",
  wordsProblems: "Problems",
  wordsProblemsetter: "Uploaded by",
  wordsProgress: "Progress",
  wordsProportion: "Proportion",
  wordsPublic: "Public",
  wordsPublicTags: "Public tags",
  wordsPublicUpdated: "Updated",
  wordsQuality: "Quality",
  wordsRanking: "Ranking",
  wordsRankingMeasurement: "How does ranking work?",
  wordsRatio: "Ratio",
  wordsReadAgain: "Read again",
  wordsReadMore: "Read more",
  wordsReason: "Reason",
  wordsRegistration: "Registration/open",
  wordsRemoveFilter: "Remove filters",
  wordsReportProblem: "Report problem",
  wordsRequired: "Required",
  wordsRequiredField: "* Required field",
  wordsReset: "omegaUp: Reset password.",
  wordsResetMessage: "Click the following link to reset your password: <a href=\"[link]\">[link]</a><br><br>If you didn't request this operation please do not click the link and make sure your account is safe.",
  wordsResult: "Answer",
  wordsReviewingProblem: "Reviewing problem",
  wordsRun: "Run",
  wordsRuns: "Submissions",
  wordsRuntime: "Runtime",
  wordsSaveChanges: "Save changes",
  wordsSaveNewOrder: "Save new order",
  wordsSchool: "School",
  wordsScore: "Score",
  wordsScoreboard: "Scoreboard",
  wordsSearch: "Search",
  wordsSearchBy: "Search by",
  wordsSeeCourse: "See course",
  wordsSeeLatestSubmissions: "See latest submissions sent by %(username)",
  wordsSeeSolution: "See Solution",
  wordsSelect: "Select",
  wordsSelectFilter: "Select a filter",
  wordsSend: "Send",
  wordsShowCasesDiff: "Show cases differences",
  wordsShowSiteAdmins: "Show site-admins",
  wordsSource: "Source",
  wordsSpanish: "Spanish",
  wordsStart: "Start",
  wordsStartTime: "Start",
  wordsStatistics: "Statistics",
  wordsStatus: "Status",
  wordsSubmissionDate: "Submission date",
  wordsSubmissions: "Submissions",
  wordsSubmissionsNotYetReviewed: "Submissions not yet reviewed",
  wordsSubmit: "Submit",
  wordsSummary: "Summary",
  wordsTime: "Date and Time",
  wordsTimeInSeconds: "Time (Sec)",
  wordsTitle: "Title",
  wordsTotal: "Total",
  wordsTotalVotes: "total votes",
  wordsUnarchive: "Unarchive",
  wordsUnarchiveCourse: "Unarchive course",
  wordsUnlimitedDuration: "Unlimited duration",
  wordsUnlockSolution: "Unlock Solution",
  wordsUpdateLecture: "Update lecture",
  wordsUpdateProblem: "Update problem",
  wordsUpload: "Upload",
  wordsUploadedOn: "Problem uploaded on: %(date)",
  wordsUsersFeedback: "Coders Feedback",
  wordsVerdict: "Verdict",
  wordsVerdictsOf: "Verdicts of %(alias)",
  wordsViewAll: "View all",
  wordsWallTimeInSeconds: "Wall-time (Sec)",
  wordsWarningProblem: "Keep with a warning",
  wordsYes: "Yes",
  zipPrepare: "Prepare zip file",
};

export {translations as default};